/* =====================================================================
   Signage.inc  |  CASE STUDIES  (verified Loox reviews, source: redesign-files/Code/src/data)
   Generated by redesign-files/tools/gen_cases.py - re-run it after changing the source data.
   Photos: complete URLs (Shopify admin > Content > Files, uploaded by redesign-files/tools/upload_cases.py).
   Order = the order on the page (photos first, strongest first, newest first within each tier).
   ===================================================================== */
window.SG_CASES = {
 "cases": [
  {
   "id": "kWdZ7Pe0XM",
   "title": "Fyne",
   "business": "Fyne",
   "industry": "",
   "name": "Aarav P.",
   "date": "Sep 2025",
   "stars": 5,
   "text": "My team loved it too. It really makes our entrance stand out.",
   "label": "3D Metal Backlit Letters",
   "type_id": "3d-metal-backlit-letters",
   "img": "https://cdn.shopify.com/s/files/1/0929/6606/0311/files/cs-030.webp?v=1791361972",
   "w": 500,
   "h": 500,
   "alt": "3D Metal Backlit Letters sign photo from customer Aarav P.",
   "tags": [
    "3D Metal Backlit Letters",
    "Illuminated",
    "3D Metal"
   ],
   "about": "Fabricated metal letters with an even halo glow on the wall behind. Premium, modern and easy to read.",
   "hl": [
    "Customer service"
   ],
   "g": "3d-metal-backlit-letters",
   "b": "other",
   "rel": [
    "Mz0k0No6mY",
    "FayaHlhvCv",
    "Am6GnHO2Zt"
   ]
  },
  {
   "id": "3cleXOnqho",
   "title": "OZ Aesthetic",
   "business": "OZ Aesthetic",
   "industry": "Aesthetic Clinic",
   "name": "Matthew S.",
   "date": "Sep 2025",
   "stars": 5,
   "text": "It took a little longer than expected but totally worth the wait. Looks stunning!",
   "label": "3D Metal Backlit Letters",
   "type_id": "3d-metal-backlit-letters",
   "img": "https://cdn.shopify.com/s/files/1/0929/6606/0311/files/cs-032.webp?v=1791361984",
   "w": 500,
   "h": 500,
   "alt": "3D Metal Backlit Letters sign photo from customer Matthew S.",
   "tags": [
    "3D Metal Backlit Letters",
    "Illuminated",
    "3D Metal"
   ],
   "about": "Fabricated metal letters with an even halo glow on the wall behind. Premium, modern and easy to read.",
   "hl": [
    "Value",
    "Matched expectations"
   ],
   "g": "3d-metal-backlit-letters",
   "b": "beauty",
   "rel": [
    "Am6GnHO2Zt",
    "kWdZ7Pe0XM",
    "lVD73SKm00"
   ]
  },
  {
   "id": "lVD73SKm00",
   "title": "Jessica T.’s 3D Metal Backlit Letters",
   "business": "",
   "industry": "Aesthetics",
   "name": "Jessica T.",
   "date": "Sep 2025",
   "stars": 5,
   "text": "Exactly what I wanted, thnkz",
   "label": "3D Metal Backlit Letters",
   "type_id": "3d-metal-backlit-letters",
   "img": "https://cdn.shopify.com/s/files/1/0929/6606/0311/files/cs-034.webp?v=1791361995",
   "w": 495,
   "h": 500,
   "alt": "3D Metal Backlit Letters sign photo from customer Jessica T.",
   "tags": [
    "3D Metal Backlit Letters",
    "Illuminated",
    "3D Metal"
   ],
   "about": "Fabricated metal letters with an even halo glow on the wall behind. Premium, modern and easy to read.",
   "hl": [
    "Matched expectations"
   ],
   "g": "3d-metal-backlit-letters",
   "b": "beauty",
   "rel": [
    "3cleXOnqho",
    "JY6F3KCgcd",
    "onGpCeTRGA"
   ]
  },
  {
   "id": "yGTvbrOmt_r",
   "title": "Marathon Auto Detailing",
   "business": "Marathon Auto Detailing",
   "industry": "Auto Detailing",
   "name": "Ishita P.",
   "date": "Oct 2025",
   "stars": 5,
   "text": "Customer service was responsive too.",
   "label": "3D Acrylic Front Lit Letters",
   "type_id": "3d-acrylic-lit-letters",
   "img": "https://cdn.shopify.com/s/files/1/0929/6606/0311/files/cs-009.webp?v=1791361857",
   "w": 375,
   "h": 500,
   "alt": "3D Acrylic Front Lit Letters sign photo from customer Ishita P.",
   "tags": [
    "3D Acrylic Front Lit Letters",
    "Illuminated",
    "3D Acrylic"
   ],
   "about": "Dimensional letters with glowing faces, lit edges or a soft halo. Crisp by day, bold after dark.",
   "hl": [
    "Customer service"
   ],
   "g": "3d-acrylic-front-lit-letters",
   "b": "pets",
   "rel": [
    "oi0jgABJXW",
    "MpB2a1rTIw",
    "N79bpNoT6y"
   ]
  },
  {
   "id": "JY6F3KCgcd",
   "title": "Drotek",
   "business": "Drotek",
   "industry": "",
   "name": "Priya D.",
   "date": "Oct 2025",
   "stars": 5,
   "text": "",
   "label": "3D Metal Backlit Letters",
   "type_id": "3d-metal-backlit-letters",
   "img": "https://cdn.shopify.com/s/files/1/0929/6606/0311/files/cs-012.webp?v=1791361873",
   "w": 500,
   "h": 374,
   "alt": "3D Metal Backlit Letters sign photo from customer Priya D.",
   "tags": [
    "3D Metal Backlit Letters",
    "Illuminated",
    "3D Metal"
   ],
   "about": "Fabricated metal letters with an even halo glow on the wall behind. Premium, modern and easy to read.",
   "hl": [],
   "g": "3d-metal-backlit-letters",
   "b": "other",
   "rel": [
    "xOVOppon6n",
    "6mE6NIV03",
    "HLwa3Bdd53"
   ]
  },
  {
   "id": "onGpCeTRGA",
   "title": "Beanery Cafe & Eatery",
   "business": "Beanery Cafe & Eatery",
   "industry": "Cafe",
   "name": "Emily F.",
   "date": "Sep 2025",
   "stars": 5,
   "text": "The sign arrived on time and was well-packed.",
   "label": "3D Metal Backlit Letters",
   "type_id": "3d-metal-backlit-letters",
   "img": "https://cdn.shopify.com/s/files/1/0929/6606/0311/files/cs-013.webp?v=1791361879",
   "w": 375,
   "h": 500,
   "alt": "3D Metal Backlit Letters sign photo from customer Emily F.",
   "tags": [
    "3D Metal Backlit Letters",
    "Illuminated",
    "3D Metal"
   ],
   "about": "Fabricated metal letters with an even halo glow on the wall behind. Premium, modern and easy to read.",
   "hl": [
    "Delivery"
   ],
   "g": "3d-metal-backlit-letters",
   "b": "food",
   "rel": [
    "6mE6NIV03",
    "HLwa3Bdd53",
    "HXGuuoRTi4"
   ]
  },
  {
   "id": "r6AIJ2ZjP2",
   "title": "Gregori International",
   "business": "Gregori International",
   "industry": "International Contractor",
   "name": "Karan S.",
   "date": "Sep 2025",
   "stars": 5,
   "text": "Impressed with the detailing. Looks really good in person, even better than the photos.",
   "label": "3D Metal Backlit Letters",
   "type_id": "3d-metal-backlit-letters",
   "img": "https://cdn.shopify.com/s/files/1/0929/6606/0311/files/cs-015.webp?v=1791361890",
   "w": 500,
   "h": 375,
   "alt": "3D Metal Backlit Letters sign photo from customer Karan S.",
   "tags": [
    "3D Metal Backlit Letters",
    "Illuminated",
    "3D Metal"
   ],
   "about": "Fabricated metal letters with an even halo glow on the wall behind. Premium, modern and easy to read.",
   "hl": [],
   "g": "3d-metal-backlit-letters",
   "b": "pro",
   "rel": [
    "HXGuuoRTi4",
    "gyCToSD9lJ",
    "6EGig6zdZ"
   ]
  },
  {
   "id": "7HlLePBkRH",
   "title": "Maple Paradise",
   "business": "Maple Paradise",
   "industry": "",
   "name": "Sarah M.",
   "date": "Sep 2025",
   "stars": 5,
   "text": "Loved it! The metal finish looks premium and gives a modern look to our space.",
   "label": "3D Metal Backlit Letters",
   "type_id": "3d-metal-backlit-letters",
   "img": "https://cdn.shopify.com/s/files/1/0929/6606/0311/files/cs-016.webp?v=1791361895",
   "w": 350,
   "h": 500,
   "alt": "3D Metal Backlit Letters sign photo from customer Sarah M.",
   "tags": [
    "3D Metal Backlit Letters",
    "Illuminated",
    "3D Metal"
   ],
   "about": "Fabricated metal letters with an even halo glow on the wall behind. Premium, modern and easy to read.",
   "hl": [
    "Quality & finish"
   ],
   "g": "3d-metal-backlit-letters",
   "b": "other",
   "rel": [
    "gyCToSD9lJ",
    "6EGig6zdZ",
    "xk9Fmup2e6"
   ]
  },
  {
   "id": "OBLhjKMhuU",
   "title": "Rohan N.’s 3D Metal Backlit Letters",
   "business": "",
   "industry": "",
   "name": "Rohan N.",
   "date": "Sep 2025",
   "stars": 5,
   "text": "Very happy with my order. Installation was simple and the end result is stunning",
   "label": "3D Metal Backlit Letters",
   "type_id": "3d-metal-backlit-letters",
   "img": "https://cdn.shopify.com/s/files/1/0929/6606/0311/files/cs-017.webp?v=1791361901",
   "w": 400,
   "h": 500,
   "alt": "3D Metal Backlit Letters sign photo from customer Rohan N.",
   "tags": [
    "3D Metal Backlit Letters",
    "Illuminated",
    "3D Metal"
   ],
   "about": "Fabricated metal letters with an even halo glow on the wall behind. Premium, modern and easy to read.",
   "hl": [
    "Installation"
   ],
   "g": "3d-metal-backlit-letters",
   "b": "other",
   "rel": [
    "6EGig6zdZ",
    "xk9Fmup2e6",
    "q5kaHp-5iZ"
   ]
  },
  {
   "id": "oi0jgABJXW",
   "title": "The Skin Edit",
   "business": "The Skin Edit",
   "industry": "Skincare",
   "name": "Ashley C.",
   "date": "Sep 2025",
   "stars": 5,
   "text": "highly recommend!",
   "label": "3D Metal Backlit Letters",
   "type_id": "3d-metal-backlit-letters",
   "img": "https://cdn.shopify.com/s/files/1/0929/6606/0311/files/cs-018.webp?v=1791361907",
   "w": 500,
   "h": 500,
   "alt": "3D Metal Backlit Letters sign photo from customer Ashley C.",
   "tags": [
    "3D Metal Backlit Letters",
    "Illuminated",
    "3D Metal"
   ],
   "about": "Fabricated metal letters with an even halo glow on the wall behind. Premium, modern and easy to read.",
   "hl": [
    "Would recommend"
   ],
   "g": "3d-metal-backlit-letters",
   "b": "beauty",
   "rel": [
    "xk9Fmup2e6",
    "q5kaHp-5iZ",
    "SKrZAjNNCH"
   ]
  },
  {
   "id": "MpB2a1rTIw",
   "title": "Breadtop",
   "business": "Breadtop",
   "industry": "",
   "name": "David C.",
   "date": "Sep 2025",
   "stars": 5,
   "text": "Will order again.",
   "label": "3D Non-Lit Letters on Backboard",
   "type_id": "3d-nonlit-backboard",
   "img": "https://cdn.shopify.com/s/files/1/0929/6606/0311/files/cs-019.webp?v=1791361912",
   "w": 500,
   "h": 500,
   "alt": "3D Non-Lit Letters on Backboard sign photo from customer David C.",
   "tags": [
    "3D Non-Lit Letters on Backboard",
    "Non-Lit",
    "Backboard"
   ],
   "about": "Dimensional letters on a custom backboard in metal, wood or painted finishes. Easy to install anywhere.",
   "hl": [
    "Would order again"
   ],
   "g": "3d-non-lit-letters-on-backboard",
   "b": "other",
   "rel": [
    "dnPI_nmAsP",
    "OhqsdlMUWNd",
    "Dww8J0OKng"
   ]
  },
  {
   "id": "N79bpNoT6y",
   "title": "Glup!",
   "business": "Glup!",
   "industry": "",
   "name": "Aditi V.",
   "date": "Sep 2025",
   "stars": 5,
   "text": "The sign came out exactly how we wanted",
   "label": "3D Metal Backlit Letters",
   "type_id": "3d-metal-backlit-letters",
   "img": "https://cdn.shopify.com/s/files/1/0929/6606/0311/files/cs-021.webp?v=1791361923",
   "w": 500,
   "h": 500,
   "alt": "3D Metal Backlit Letters sign photo from customer Aditi V.",
   "tags": [
    "3D Metal Backlit Letters",
    "Illuminated",
    "3D Metal"
   ],
   "about": "Fabricated metal letters with an even halo glow on the wall behind. Premium, modern and easy to read.",
   "hl": [
    "Matched expectations"
   ],
   "g": "3d-metal-backlit-letters",
   "b": "other",
   "rel": [
    "-7J9xLU2rP",
    "CFdTomC1Bt",
    "BjapyJbI-Y"
   ]
  },
  {
   "id": "v62DiEsFda",
   "title": "James P.’s 3D Metal Backlit Letters",
   "business": "",
   "industry": "",
   "name": "James P.",
   "date": "Sep 2025",
   "stars": 5,
   "text": "The quality is outstanding! The finish and brightness are just perfect.looks premium.",
   "label": "3D Metal Backlit Letters",
   "type_id": "3d-metal-backlit-letters",
   "img": "https://cdn.shopify.com/s/files/1/0929/6606/0311/files/cs-023.webp?v=1791361933",
   "w": 375,
   "h": 500,
   "alt": "3D Metal Backlit Letters sign photo from customer James P.",
   "tags": [
    "3D Metal Backlit Letters",
    "Illuminated",
    "3D Metal"
   ],
   "about": "Fabricated metal letters with an even halo glow on the wall behind. Premium, modern and easy to read.",
   "hl": [
    "Quality & finish"
   ],
   "g": "3d-metal-backlit-letters",
   "b": "other",
   "rel": [
    "BjapyJbI-Y",
    "gXNm6y3ufY",
    "fu7oflBzzm"
   ]
  },
  {
   "id": "96lDXjbjhpA",
   "title": "The Beautique",
   "business": "The Beautique",
   "industry": "Beauty",
   "name": "Alisha_kh",
   "date": "Sep 2025",
   "stars": 5,
   "text": "I loved your services",
   "label": "2D Metal Letters",
   "type_id": "metal-2d",
   "img": "https://cdn.shopify.com/s/files/1/0929/6606/0311/files/cs-024.webp?v=1791361939",
   "w": 500,
   "h": 375,
   "alt": "2D Metal Letters sign photo from customer Alisha_kh",
   "tags": [
    "2D Metal Letters",
    "Non-Lit",
    "Metal"
   ],
   "about": "Laser-cut logos and lettering in slim 2mm or 5mm metal. Precise, flat and built to last.",
   "hl": [
    "Customer service"
   ],
   "g": "2d-metal-letters",
   "b": "beauty",
   "rel": [
    "V-48u5pTF-",
    "juVxOxrTlt",
    "zOKKX_uQwF"
   ]
  },
  {
   "id": "7kzKeS9nSLS",
   "title": "Kaya Hair & Beauty",
   "business": "Kaya Hair & Beauty",
   "industry": "Hair & Beauty",
   "name": "Olivia G.",
   "date": "Sep 2025",
   "stars": 5,
   "text": "I love it, thanku guys",
   "label": "3D Acrylic Non-Lit Letters",
   "type_id": "3d-acrylic-nonlit",
   "img": "https://cdn.shopify.com/s/files/1/0929/6606/0311/files/cs-025.webp?v=1791361944",
   "w": 466,
   "h": 500,
   "alt": "3D Acrylic Non-Lit Letters sign photo from customer Olivia G.",
   "tags": [
    "3D Acrylic Non-Lit Letters",
    "Non-Lit",
    "3D Acrylic"
   ],
   "about": "Lightweight, colorful letters and logos in layered or flat finishes. Ideal for interiors.",
   "hl": [],
   "g": "3d-acrylic-non-lit-letters",
   "b": "beauty",
   "rel": [
    "HfsVqObAzH",
    "KmgtExfHZ_",
    "UCPhdPHu-3"
   ]
  },
  {
   "id": "hyWsr3dT1w",
   "title": "Flowers Shop",
   "business": "Flowers Shop",
   "industry": "Florist",
   "name": "Maya S.",
   "date": "Sep 2025",
   "stars": 4,
   "text": "loveeeeeeeee it",
   "label": "Projecting Sign",
   "type_id": "light-box-double",
   "img": "https://cdn.shopify.com/s/files/1/0929/6606/0311/files/cs-026.webp?v=1791361950",
   "w": 333,
   "h": 500,
   "alt": "Projecting Sign sign photo from customer Maya S.",
   "tags": [
    "Projecting Sign",
    "Illuminated",
    "Light Box"
   ],
   "about": "Projects from the wall so pedestrians can see it from both directions. Square, round or custom shapes.",
   "hl": [],
   "g": "projecting-sign",
   "b": "pets",
   "rel": [
    "AZmm7zcQ2",
    "iwpuf9DArY",
    "1jaEgEoS2k"
   ]
  },
  {
   "id": "jvagL1_NUp",
   "title": "Totomo Cattery",
   "business": "Totomo Cattery",
   "industry": "Cattery",
   "name": "Ethan C.",
   "date": "Sep 2025",
   "stars": 5,
   "text": "sleek like i wanted",
   "label": "2D Metal Letters",
   "type_id": "metal-2d",
   "img": "https://cdn.shopify.com/s/files/1/0929/6606/0311/files/cs-027.webp?v=1791361955",
   "w": 375,
   "h": 500,
   "alt": "2D Metal Letters sign photo from customer Ethan C.",
   "tags": [
    "2D Metal Letters",
    "Non-Lit",
    "Metal"
   ],
   "about": "Laser-cut logos and lettering in slim 2mm or 5mm metal. Precise, flat and built to last.",
   "hl": [],
   "g": "2d-metal-letters",
   "b": "pets",
   "rel": [
    "I_9T93hutuv",
    "96lDXjbjhpA",
    "9fNxcBuZus"
   ]
  },
  {
   "id": "oP5SMxDyz8",
   "title": "FYC",
   "business": "FYC",
   "industry": "",
   "name": "Benjamin C.",
   "date": "Sep 2025",
   "stars": 5,
   "text": "Honestly, I was skeptical ordering online, but you guys delivered exactly what you promised.",
   "label": "3D Metal Backlit Letters",
   "type_id": "3d-metal-backlit-letters",
   "img": "https://cdn.shopify.com/s/files/1/0929/6606/0311/files/cs-028.webp?v=1791361961",
   "w": 375,
   "h": 500,
   "alt": "3D Metal Backlit Letters sign photo from customer Benjamin C.",
   "tags": [
    "3D Metal Backlit Letters",
    "Illuminated",
    "3D Metal"
   ],
   "about": "Fabricated metal letters with an even halo glow on the wall behind. Premium, modern and easy to read.",
   "hl": [
    "Matched expectations"
   ],
   "g": "3d-metal-backlit-letters",
   "b": "other",
   "rel": [
    "3fHTrWxlZs",
    "vhDDfsDZlb",
    "Mz0k0No6mY"
   ]
  },
  {
   "id": "KmgtExfHZ_",
   "title": "Chloe A.’s 3D Acrylic Non-Lit Letters",
   "business": "",
   "industry": "Nail Salon",
   "name": "Chloe A.",
   "date": "Sep 2025",
   "stars": 5,
   "text": "Simple, elegant, and professional, amazing guys",
   "label": "3D Acrylic Non-Lit Letters",
   "type_id": "3d-acrylic-nonlit",
   "img": "https://cdn.shopify.com/s/files/1/0929/6606/0311/files/cs-029.webp?v=1791361966",
   "w": 500,
   "h": 500,
   "alt": "3D Acrylic Non-Lit Letters sign photo from customer Chloe A.",
   "tags": [
    "3D Acrylic Non-Lit Letters",
    "Non-Lit",
    "3D Acrylic"
   ],
   "about": "Lightweight, colorful letters and logos in layered or flat finishes. Ideal for interiors.",
   "hl": [
    "Customer service"
   ],
   "g": "3d-acrylic-non-lit-letters",
   "b": "beauty",
   "rel": [
    "xsJq4XvV4L",
    "C6LAj9rHzh",
    "3a3edjYAWg"
   ]
  },
  {
   "id": "UCPhdPHu-3",
   "title": "Elite Nails & Beauty",
   "business": "Elite Nails & Beauty",
   "industry": "Nails & Beauty",
   "name": "Oliver S.",
   "date": "Sep 2025",
   "stars": 5,
   "text": "The price felt high at first but after seeing the result, I think it was worth every penny",
   "label": "3D Acrylic Non-Lit Letters",
   "type_id": "3d-acrylic-nonlit",
   "img": "https://cdn.shopify.com/s/files/1/0929/6606/0311/files/cs-031.webp?v=1791361978",
   "w": 374,
   "h": 500,
   "alt": "3D Acrylic Non-Lit Letters sign photo from customer Oliver S.",
   "tags": [
    "3D Acrylic Non-Lit Letters",
    "Non-Lit",
    "3D Acrylic"
   ],
   "about": "Lightweight, colorful letters and logos in layered or flat finishes. Ideal for interiors.",
   "hl": [
    "Value"
   ],
   "g": "3d-acrylic-non-lit-letters",
   "b": "beauty",
   "rel": [
    "3a3edjYAWg",
    "jlkPC_Qjz_",
    "ZoxB5GyUtD"
   ]
  },
  {
   "id": "9fNxcBuZus",
   "title": "ZBS Beauty Studios",
   "business": "ZBS Beauty Studios",
   "industry": "Beauty Salon",
   "name": "Brown S.",
   "date": "Sep 2025",
   "stars": 5,
   "text": "Installation was easier than I thought",
   "label": "2D Metal Letters",
   "type_id": "metal-2d",
   "img": "https://cdn.shopify.com/s/files/1/0929/6606/0311/files/cs-033.webp?v=1791361990",
   "w": 400,
   "h": 500,
   "alt": "2D Metal Letters sign photo from customer Brown S.",
   "tags": [
    "2D Metal Letters",
    "Non-Lit",
    "Metal"
   ],
   "about": "Laser-cut logos and lettering in slim 2mm or 5mm metal. Precise, flat and built to last.",
   "hl": [
    "Installation"
   ],
   "g": "2d-metal-letters",
   "b": "beauty",
   "rel": [
    "zOKKX_uQwF",
    "I_9T93hutuv",
    "96lDXjbjhpA"
   ]
  },
  {
   "id": "RPDJITOFzM",
   "title": "The Beauty & Brow Parlour",
   "business": "The Beauty & Brow Parlour",
   "industry": "Beauty Parlour",
   "name": "Ashley T.",
   "date": "Sep 2025",
   "stars": 5,
   "text": "Really happy with the outcome",
   "label": "3D Non-Lit Letters on Backboard",
   "type_id": "3d-nonlit-backboard",
   "img": "https://cdn.shopify.com/s/files/1/0929/6606/0311/files/cs-035.webp?v=1791362000",
   "w": 375,
   "h": 500,
   "alt": "3D Non-Lit Letters on Backboard sign photo from customer Ashley T.",
   "tags": [
    "3D Non-Lit Letters on Backboard",
    "Non-Lit",
    "Backboard"
   ],
   "about": "Dimensional letters on a custom backboard in metal, wood or painted finishes. Easy to install anywhere.",
   "hl": [],
   "g": "3d-non-lit-letters-on-backboard",
   "b": "beauty",
   "rel": [
    "AMXMzUJF-k",
    "MpB2a1rTIw",
    "dnPI_nmAsP"
   ]
  },
  {
   "id": "hJFnmDGKho",
   "title": "Cloud",
   "business": "Cloud",
   "industry": "Lash Salon",
   "name": "Michael J.",
   "date": "Sep 2025",
   "stars": 5,
   "text": "arrived with no damage. Happy customer here",
   "label": "3D Metal Backlit Letters",
   "type_id": "3d-metal-backlit-letters",
   "img": "https://cdn.shopify.com/s/files/1/0929/6606/0311/files/cs-036.webp?v=1791362006",
   "w": 375,
   "h": 500,
   "alt": "3D Metal Backlit Letters sign photo from customer Michael J.",
   "tags": [
    "3D Metal Backlit Letters",
    "Illuminated",
    "3D Metal"
   ],
   "about": "Fabricated metal letters with an even halo glow on the wall behind. Premium, modern and easy to read.",
   "hl": [
    "Delivery"
   ],
   "g": "3d-metal-backlit-letters",
   "b": "beauty",
   "rel": [
    "JY6F3KCgcd",
    "onGpCeTRGA",
    "r6AIJ2ZjP2"
   ]
  },
  {
   "id": "CrqmjEBhmZ",
   "title": "Davis E.’s Light Box Sign",
   "business": "",
   "industry": "",
   "name": "Davis E.",
   "date": "Sep 2025",
   "stars": 5,
   "text": "",
   "label": "Light Box Sign",
   "type_id": "light-box-single",
   "img": "https://cdn.shopify.com/s/files/1/0929/6606/0311/files/cs-037.webp?v=1791362011",
   "w": 500,
   "h": 377,
   "alt": "Light Box Sign sign photo from customer Davis E.",
   "tags": [
    "Light Box Sign",
    "Illuminated",
    "Light Box"
   ],
   "about": "A wall-mounted illuminated cabinet that lights your entire logo evenly. Simple, bright and cost-effective.",
   "hl": [],
   "g": "light-box-sign",
   "b": "other",
   "rel": [
    "6EGig6zdZ",
    "xk9Fmup2e6",
    "q5kaHp-5iZ"
   ]
  },
  {
   "id": "IF8e6JU6i1",
   "title": "The Wee Hut",
   "business": "The Wee Hut",
   "industry": "",
   "name": "Daniel A.",
   "date": "Sep 2025",
   "stars": 4,
   "text": "",
   "label": "3D Acrylic Non-Lit Letters",
   "type_id": "3d-acrylic-nonlit",
   "img": "https://cdn.shopify.com/s/files/1/0929/6606/0311/files/cs-038.webp?v=1791362017",
   "w": 375,
   "h": 500,
   "alt": "3D Acrylic Non-Lit Letters sign photo from customer Daniel A.",
   "tags": [
    "3D Acrylic Non-Lit Letters",
    "Non-Lit",
    "3D Acrylic"
   ],
   "about": "Lightweight, colorful letters and logos in layered or flat finishes. Ideal for interiors.",
   "hl": [],
   "g": "3d-acrylic-non-lit-letters",
   "b": "other",
   "rel": [
    "HfsVqObAzH",
    "7kzKeS9nSLS",
    "KmgtExfHZ_"
   ]
  },
  {
   "id": "xOVOppon6n",
   "title": "Jolyn Clinic",
   "business": "Jolyn Clinic",
   "industry": "Clinic",
   "name": "Priya S.",
   "date": "Sep 2025",
   "stars": 5,
   "text": "Didn’t expect it to be this good honestly. The finish is clean, and the letters look premium.",
   "label": "3D Metal Backlit Letters",
   "type_id": "3d-metal-backlit-letters",
   "img": "https://cdn.shopify.com/s/files/1/0929/6606/0311/files/cs-039.webp?v=1791362023",
   "w": 400,
   "h": 500,
   "alt": "3D Metal Backlit Letters sign photo from customer Priya S.",
   "tags": [
    "3D Metal Backlit Letters",
    "Illuminated",
    "3D Metal"
   ],
   "about": "Fabricated metal letters with an even halo glow on the wall behind. Premium, modern and easy to read.",
   "hl": [
    "Quality & finish",
    "Matched expectations"
   ],
   "g": "3d-metal-backlit-letters",
   "b": "health",
   "rel": [
    "7HlLePBkRH",
    "OBLhjKMhuU",
    "oi0jgABJXW"
   ]
  },
  {
   "id": "kVjEqjKk1F",
   "title": "Lolo",
   "business": "Lolo",
   "industry": "",
   "name": "Sarah",
   "date": "Sep 2025",
   "stars": 5,
   "text": "The whole process was smooth, from ordering to delivery. I’ll be recommending you guys for sure.",
   "label": "Raceway-Mounted Letters",
   "type_id": "3d-acrylic-lit-backboard",
   "img": "https://cdn.shopify.com/s/files/1/0929/6606/0311/files/cs-040.webp?v=1791362028",
   "w": 500,
   "h": 500,
   "alt": "Raceway-Mounted Letters sign photo from customer Sarah",
   "tags": [
    "Raceway-Mounted Letters",
    "Illuminated",
    "3D Acrylic"
   ],
   "about": "Lit letters set on a backboard or raceway, giving uneven walls a clean, framed illuminated look.",
   "hl": [
    "Would recommend"
   ],
   "g": "raceway-mounted-letters",
   "b": "other",
   "rel": [
    "SKrZAjNNCH",
    "-7J9xLU2rP",
    "CFdTomC1Bt"
   ]
  },
  {
   "id": "6mE6NIV03",
   "title": "Urban Rose Beauty London",
   "business": "Urban Rose Beauty London",
   "industry": "Beauty",
   "name": "Ames M.",
   "date": "Sep 2025",
   "stars": 5,
   "text": "Exactly what I needed for my shop, looks awesome when lit up at night.",
   "label": "3D Metal Backlit Letters",
   "type_id": "3d-metal-backlit-letters",
   "img": "https://cdn.shopify.com/s/files/1/0929/6606/0311/files/cs-041.webp?v=1791362034",
   "w": 500,
   "h": 375,
   "alt": "3D Metal Backlit Letters sign photo from customer Ames M.",
   "tags": [
    "3D Metal Backlit Letters",
    "Illuminated",
    "3D Metal"
   ],
   "about": "Fabricated metal letters with an even halo glow on the wall behind. Premium, modern and easy to read.",
   "hl": [
    "Matched expectations"
   ],
   "g": "3d-metal-backlit-letters",
   "b": "beauty",
   "rel": [
    "oi0jgABJXW",
    "N79bpNoT6y",
    "v62DiEsFda"
   ]
  },
  {
   "id": "dnPI_nmAsP",
   "title": "Coco Beauty Bar",
   "business": "Coco Beauty Bar",
   "industry": "Beauty Bar",
   "name": "Emily C.",
   "date": "Aug 2025",
   "stars": 5,
   "text": "Couldn’t be happier with the final result,It gives my salon entrance a very polished and unique look",
   "label": "3D Non-Lit Letters on Backboard",
   "type_id": "3d-nonlit-backboard",
   "img": "https://cdn.shopify.com/s/files/1/0929/6606/0311/files/cs-042.webp?v=1791362039",
   "w": 375,
   "h": 500,
   "alt": "3D Non-Lit Letters on Backboard sign photo from customer Emily C.",
   "tags": [
    "3D Non-Lit Letters on Backboard",
    "Non-Lit",
    "Backboard"
   ],
   "about": "Dimensional letters on a custom backboard in metal, wood or painted finishes. Easy to install anywhere.",
   "hl": [
    "Quality & finish"
   ],
   "g": "3d-non-lit-letters-on-backboard",
   "b": "beauty",
   "rel": [
    "RdgVv2OqQg",
    "OOQEcRU1yn",
    "AMXMzUJF-k"
   ]
  },
  {
   "id": "HLwa3Bdd53",
   "title": "Skinney Medspa + Wellness",
   "business": "Skinney Medspa + Wellness",
   "industry": "Medspa & Wellness",
   "name": "Ayesha K.",
   "date": "Aug 2025",
   "stars": 5,
   "text": "",
   "label": "3D Metal Backlit Letters",
   "type_id": "3d-metal-backlit-letters",
   "img": "https://cdn.shopify.com/s/files/1/0929/6606/0311/files/cs-043.webp?v=1791362045",
   "w": 400,
   "h": 500,
   "alt": "3D Metal Backlit Letters sign photo from customer Ayesha K.",
   "tags": [
    "3D Metal Backlit Letters",
    "Illuminated",
    "3D Metal"
   ],
   "about": "Fabricated metal letters with an even halo glow on the wall behind. Premium, modern and easy to read.",
   "hl": [],
   "g": "3d-metal-backlit-letters",
   "b": "beauty",
   "rel": [
    "v62DiEsFda",
    "oP5SMxDyz8",
    "hJFnmDGKho"
   ]
  },
  {
   "id": "xsJq4XvV4L",
   "title": "Miracle",
   "business": "Miracle",
   "industry": "",
   "name": "Daniel R.",
   "date": "Aug 2025",
   "stars": 5,
   "text": "It lights up perfectly and gives my café the modern look I was hoping for. Delivery was smooth, and the packaging kept everything safe. Highly recommend!",
   "label": "3D Acrylic Non-Lit Letters",
   "type_id": "3d-acrylic-nonlit",
   "img": "https://cdn.shopify.com/s/files/1/0929/6606/0311/files/cs-044.webp?v=1791362050",
   "w": 500,
   "h": 500,
   "alt": "3D Acrylic Non-Lit Letters sign photo from customer Daniel R.",
   "tags": [
    "3D Acrylic Non-Lit Letters",
    "Non-Lit",
    "3D Acrylic"
   ],
   "about": "Lightweight, colorful letters and logos in layered or flat finishes. Ideal for interiors.",
   "hl": [
    "Delivery",
    "Would recommend"
   ],
   "g": "3d-acrylic-non-lit-letters",
   "b": "other",
   "rel": [
    "3a3edjYAWg",
    "jlkPC_Qjz_",
    "ZoxB5GyUtD"
   ]
  },
  {
   "id": "CKQ0OnLGuQ",
   "title": "Gallery 716",
   "business": "Gallery 716",
   "industry": "Gallery",
   "name": "Sarah M.",
   "date": "Aug 2025",
   "stars": 5,
   "text": "it makes my little shop stand out so nicely on the street.",
   "label": "Projecting Sign",
   "type_id": "light-box-double",
   "img": "https://cdn.shopify.com/s/files/1/0929/6606/0311/files/cs-045.webp?v=1791362056",
   "w": 400,
   "h": 500,
   "alt": "Projecting Sign sign photo from customer Sarah M.",
   "tags": [
    "Projecting Sign",
    "Illuminated",
    "Light Box"
   ],
   "about": "Projects from the wall so pedestrians can see it from both directions. Square, round or custom shapes.",
   "hl": [],
   "g": "projecting-sign",
   "b": "pro",
   "rel": [
    "iwpuf9DArY",
    "1jaEgEoS2k",
    "JpsTv_iuxRr"
   ]
  },
  {
   "id": "HXGuuoRTi4",
   "title": "White & Co. Real Estate",
   "business": "White & Co. Real Estate",
   "industry": "Real Estate",
   "name": "Rachel",
   "date": "Aug 2025",
   "stars": 5,
   "text": "This is exactly the kind of sign we wanted,",
   "label": "3D Metal Backlit Letters",
   "type_id": "3d-metal-backlit-letters",
   "img": "https://cdn.shopify.com/s/files/1/0929/6606/0311/files/cs-046.webp?v=1791362062",
   "w": 400,
   "h": 500,
   "alt": "3D Metal Backlit Letters sign photo from customer Rachel",
   "tags": [
    "3D Metal Backlit Letters",
    "Illuminated",
    "3D Metal"
   ],
   "about": "Fabricated metal letters with an even halo glow on the wall behind. Premium, modern and easy to read.",
   "hl": [
    "Matched expectations"
   ],
   "g": "3d-metal-backlit-letters",
   "b": "pro",
   "rel": [
    "xOVOppon6n",
    "6mE6NIV03",
    "HLwa3Bdd53"
   ]
  },
  {
   "id": "_EPSeNGoQD",
   "title": "Enderfy",
   "business": "Enderfy",
   "industry": "",
   "name": "Daniel B.",
   "date": "Aug 2025",
   "stars": 5,
   "text": "looovve it ,Got a bunch of compliments already.",
   "label": "3D Metal Non-Lit Letters",
   "type_id": "3d-metal-nonlit",
   "img": "https://cdn.shopify.com/s/files/1/0929/6606/0311/files/cs-047.webp?v=1791362067",
   "w": 375,
   "h": 500,
   "alt": "3D Metal Non-Lit Letters sign photo from customer Daniel B.",
   "tags": [
    "3D Metal Non-Lit Letters",
    "Non-Lit",
    "3D Metal"
   ],
   "about": "Brushed, polished or painted metal letters with real depth. No wiring, no maintenance.",
   "hl": [],
   "g": "3d-metal-non-lit-letters",
   "b": "other",
   "rel": [
    "wI7PnRISP5",
    "NM7cWKLrNw",
    "WBniW_7kXq"
   ]
  },
  {
   "id": "C6LAj9rHzh",
   "title": "JV Nail & Waxing",
   "business": "JV Nail & Waxing",
   "industry": "Nails & Waxing",
   "name": "Amanda C.",
   "date": "Jul 2025",
   "stars": 5,
   "text": "Makes our reception look so much more welcoming",
   "label": "3D Acrylic Non-Lit Letters",
   "type_id": "3d-acrylic-nonlit",
   "img": "https://cdn.shopify.com/s/files/1/0929/6606/0311/files/cs-048.webp?v=1791362072",
   "w": 500,
   "h": 393,
   "alt": "3D Acrylic Non-Lit Letters sign photo from customer Amanda C.",
   "tags": [
    "3D Acrylic Non-Lit Letters",
    "Non-Lit",
    "3D Acrylic"
   ],
   "about": "Lightweight, colorful letters and logos in layered or flat finishes. Ideal for interiors.",
   "hl": [],
   "g": "3d-acrylic-non-lit-letters",
   "b": "beauty",
   "rel": [
    "Jo8EZNzc-T",
    "0V-XNsu89W",
    "_hoSdKdcfs"
   ]
  },
  {
   "id": "gyCToSD9lJ",
   "title": "SkinNature",
   "business": "SkinNature",
   "industry": "Skincare",
   "name": "James W.",
   "date": "Jul 2025",
   "stars": 4,
   "text": "it's bright but classy, exactly what I wanted.",
   "label": "3D Metal Backlit Letters",
   "type_id": "3d-metal-backlit-letters",
   "img": "https://cdn.shopify.com/s/files/1/0929/6606/0311/files/cs-049.webp?v=1791362077",
   "w": 500,
   "h": 427,
   "alt": "3D Metal Backlit Letters sign photo from customer James W.",
   "tags": [
    "3D Metal Backlit Letters",
    "Illuminated",
    "3D Metal"
   ],
   "about": "Fabricated metal letters with an even halo glow on the wall behind. Premium, modern and easy to read.",
   "hl": [
    "Quality & finish",
    "Matched expectations"
   ],
   "g": "3d-metal-backlit-letters",
   "b": "beauty",
   "rel": [
    "HXGuuoRTi4",
    "6EGig6zdZ",
    "xk9Fmup2e6"
   ]
  },
  {
   "id": "6EGig6zdZ",
   "title": "Signature Smile Dental",
   "business": "Signature Smile Dental",
   "industry": "Dental",
   "name": "Jessica",
   "date": "Jul 2025",
   "stars": 5,
   "text": "The whole process was super easy and it arrived faster than I expected.",
   "label": "3D Metal Backlit Letters",
   "type_id": "3d-metal-backlit-letters",
   "img": "https://cdn.shopify.com/s/files/1/0929/6606/0311/files/cs-050.webp?v=1791362083",
   "w": 400,
   "h": 500,
   "alt": "3D Metal Backlit Letters sign photo from customer Jessica",
   "tags": [
    "3D Metal Backlit Letters",
    "Illuminated",
    "3D Metal"
   ],
   "about": "Fabricated metal letters with an even halo glow on the wall behind. Premium, modern and easy to read.",
   "hl": [
    "Delivery",
    "Matched expectations"
   ],
   "g": "3d-metal-backlit-letters",
   "b": "health",
   "rel": [
    "gyCToSD9lJ",
    "xk9Fmup2e6",
    "q5kaHp-5iZ"
   ]
  },
  {
   "id": "xk9Fmup2e6",
   "title": "Maison Adora",
   "business": "Maison Adora",
   "industry": "",
   "name": "Michael T.",
   "date": "Jul 2025",
   "stars": 5,
   "text": "Couldn’t be happier with how this turned out. LIGHting is just the right brightness and the metal feels really solid. We’ve already had two people walk in just to ask where we got it made",
   "label": "3D Metal Backlit Letters",
   "type_id": "3d-metal-backlit-letters",
   "img": "https://cdn.shopify.com/s/files/1/0929/6606/0311/files/cs-051.webp?v=1791362088",
   "w": 400,
   "h": 500,
   "alt": "3D Metal Backlit Letters sign photo from customer Michael T.",
   "tags": [
    "3D Metal Backlit Letters",
    "Illuminated",
    "3D Metal"
   ],
   "about": "Fabricated metal letters with an even halo glow on the wall behind. Premium, modern and easy to read.",
   "hl": [
    "Quality & finish"
   ],
   "g": "3d-metal-backlit-letters",
   "b": "other",
   "rel": [
    "6EGig6zdZ",
    "q5kaHp-5iZ",
    "SKrZAjNNCH"
   ]
  },
  {
   "id": "q5kaHp-5iZ",
   "title": "The Cherry Tree Bakery Cafe",
   "business": "The Cherry Tree Bakery Cafe",
   "industry": "Bakery Cafe",
   "name": "Daniel W.",
   "date": "Jul 2025",
   "stars": 5,
   "text": "Very professional experience overall, sign installation guide was also very helpful. will order more",
   "label": "3D Metal Backlit Letters",
   "type_id": "3d-metal-backlit-letters",
   "img": "https://cdn.shopify.com/s/files/1/0929/6606/0311/files/cs-052.webp?v=1791362094",
   "w": 281,
   "h": 500,
   "alt": "3D Metal Backlit Letters sign photo from customer Daniel W.",
   "tags": [
    "3D Metal Backlit Letters",
    "Illuminated",
    "3D Metal"
   ],
   "about": "Fabricated metal letters with an even halo glow on the wall behind. Premium, modern and easy to read.",
   "hl": [
    "Installation",
    "Customer service",
    "Would order again"
   ],
   "g": "3d-metal-backlit-letters",
   "b": "food",
   "rel": [
    "xk9Fmup2e6",
    "SKrZAjNNCH",
    "-7J9xLU2rP"
   ]
  },
  {
   "id": "3a3edjYAWg",
   "title": "Nail Bar Lounge",
   "business": "Nail Bar Lounge",
   "industry": "Nail Bar",
   "name": "Hannah",
   "date": "Jul 2025",
   "stars": 5,
   "text": "Packaging was secure.",
   "label": "3D Acrylic Non-Lit Letters",
   "type_id": "3d-acrylic-nonlit",
   "img": "https://cdn.shopify.com/s/files/1/0929/6606/0311/files/cs-053.webp?v=1791362099",
   "w": 500,
   "h": 334,
   "alt": "3D Acrylic Non-Lit Letters sign photo from customer Hannah",
   "tags": [
    "3D Acrylic Non-Lit Letters",
    "Non-Lit",
    "3D Acrylic"
   ],
   "about": "Lightweight, colorful letters and logos in layered or flat finishes. Ideal for interiors.",
   "hl": [],
   "g": "3d-acrylic-non-lit-letters",
   "b": "beauty",
   "rel": [
    "KmgtExfHZ_",
    "UCPhdPHu-3",
    "IF8e6JU6i1"
   ]
  },
  {
   "id": "SKrZAjNNCH",
   "title": "Grand Prairie Chamber of Commerce",
   "business": "Grand Prairie Chamber of Commerce",
   "industry": "Chamber of Commerce",
   "name": "Amina F.",
   "date": "Jul 2025",
   "stars": 5,
   "text": "metal finish looks so premium",
   "label": "3D Metal Backlit Letters",
   "type_id": "3d-metal-backlit-letters",
   "img": "https://cdn.shopify.com/s/files/1/0929/6606/0311/files/cs-054.webp?v=1791362105",
   "w": 500,
   "h": 500,
   "alt": "3D Metal Backlit Letters sign photo from customer Amina F.",
   "tags": [
    "3D Metal Backlit Letters",
    "Illuminated",
    "3D Metal"
   ],
   "about": "Fabricated metal letters with an even halo glow on the wall behind. Premium, modern and easy to read.",
   "hl": [
    "Quality & finish"
   ],
   "g": "3d-metal-backlit-letters",
   "b": "pro",
   "rel": [
    "-7J9xLU2rP",
    "CFdTomC1Bt",
    "BjapyJbI-Y"
   ]
  },
  {
   "id": "-7J9xLU2rP",
   "title": "Glam Monte Carlo",
   "business": "Glam Monte Carlo",
   "industry": "",
   "name": "James P.",
   "date": "Jul 2025",
   "stars": 5,
   "text": "Will definitely order again for our next branch",
   "label": "3D Metal Backlit Letters",
   "type_id": "3d-metal-backlit-letters",
   "img": "https://cdn.shopify.com/s/files/1/0929/6606/0311/files/cs-055.webp?v=1791362110",
   "w": 436,
   "h": 500,
   "alt": "3D Metal Backlit Letters sign photo from customer James P.",
   "tags": [
    "3D Metal Backlit Letters",
    "Illuminated",
    "3D Metal"
   ],
   "about": "Fabricated metal letters with an even halo glow on the wall behind. Premium, modern and easy to read.",
   "hl": [
    "Would order again"
   ],
   "g": "3d-metal-backlit-letters",
   "b": "other",
   "rel": [
    "CFdTomC1Bt",
    "BjapyJbI-Y",
    "gXNm6y3ufY"
   ]
  },
  {
   "id": "CFdTomC1Bt",
   "title": "Food Fashion Lifestyle",
   "business": "Food Fashion Lifestyle",
   "industry": "",
   "name": "Sophia T.",
   "date": "Jul 2025",
   "stars": 5,
   "text": "Absolutely loved the sign! The quality exceeded my expectations and the team was super helpful during customization.",
   "label": "3D Metal Backlit Letters",
   "type_id": "3d-metal-backlit-letters",
   "img": "https://cdn.shopify.com/s/files/1/0929/6606/0311/files/cs-056.webp?v=1791362116",
   "w": 281,
   "h": 500,
   "alt": "3D Metal Backlit Letters sign photo from customer Sophia T.",
   "tags": [
    "3D Metal Backlit Letters",
    "Illuminated",
    "3D Metal"
   ],
   "about": "Fabricated metal letters with an even halo glow on the wall behind. Premium, modern and easy to read.",
   "hl": [
    "Quality & finish",
    "Customer service",
    "Mockup & customization",
    "Matched expectations"
   ],
   "g": "3d-metal-backlit-letters",
   "b": "other",
   "rel": [
    "BjapyJbI-Y",
    "gXNm6y3ufY",
    "fu7oflBzzm"
   ]
  },
  {
   "id": "OhqsdlMUWNd",
   "title": "GuzmanGray",
   "business": "GuzmanGray",
   "industry": "",
   "name": "Lisa S.",
   "date": "Jun 2025",
   "stars": 5,
   "text": "They hit the balance of bold and classy perfectly",
   "label": "3D Non-Lit Letters on Backboard",
   "type_id": "3d-nonlit-backboard",
   "img": "https://cdn.shopify.com/s/files/1/0929/6606/0311/files/cs-057.webp?v=1791362121",
   "w": 500,
   "h": 375,
   "alt": "3D Non-Lit Letters on Backboard sign photo from customer Lisa S.",
   "tags": [
    "3D Non-Lit Letters on Backboard",
    "Non-Lit",
    "Backboard"
   ],
   "about": "Dimensional letters on a custom backboard in metal, wood or painted finishes. Easy to install anywhere.",
   "hl": [],
   "g": "3d-non-lit-letters-on-backboard",
   "b": "other",
   "rel": [
    "Dww8J0OKng",
    "A0HNd4ni2Y",
    "yM7iwtYt_KM"
   ]
  },
  {
   "id": "Dww8J0OKng",
   "title": "Nicholas B.’s 3D Non-Lit Letters on Backboard",
   "business": "",
   "industry": "Law Firm",
   "name": "Nicholas B.",
   "date": "Jun 2025",
   "stars": 5,
   "text": "",
   "label": "3D Non-Lit Letters on Backboard",
   "type_id": "3d-nonlit-backboard",
   "img": "https://cdn.shopify.com/s/files/1/0929/6606/0311/files/cs-058.webp?v=1791362126",
   "w": 500,
   "h": 372,
   "alt": "3D Non-Lit Letters on Backboard sign photo from customer Nicholas B.",
   "tags": [
    "3D Non-Lit Letters on Backboard",
    "Non-Lit",
    "Backboard"
   ],
   "about": "Dimensional letters on a custom backboard in metal, wood or painted finishes. Easy to install anywhere.",
   "hl": [],
   "g": "3d-non-lit-letters-on-backboard",
   "b": "pro",
   "rel": [
    "A0HNd4ni2Y",
    "yM7iwtYt_KM",
    "RdgVv2OqQg"
   ]
  },
  {
   "id": "BjapyJbI-Y",
   "title": "Vee Nails & More",
   "business": "Vee Nails & More",
   "industry": "Nails",
   "name": "Allison B.",
   "date": "Jun 2025",
   "stars": 5,
   "text": "I was nervous at first but they walked us through everything and delivered",
   "label": "3D Metal Backlit Letters",
   "type_id": "3d-metal-backlit-letters",
   "img": "https://cdn.shopify.com/s/files/1/0929/6606/0311/files/cs-059.webp?v=1791362131",
   "w": 500,
   "h": 500,
   "alt": "3D Metal Backlit Letters sign photo from customer Allison B.",
   "tags": [
    "3D Metal Backlit Letters",
    "Illuminated",
    "3D Metal"
   ],
   "about": "Fabricated metal letters with an even halo glow on the wall behind. Premium, modern and easy to read.",
   "hl": [],
   "g": "3d-metal-backlit-letters",
   "b": "beauty",
   "rel": [
    "TuuEs0Jawu",
    "jQeZqCjf3M",
    "3fHTrWxlZs"
   ]
  },
  {
   "id": "A0HNd4ni2Y",
   "title": "Haigh's Chocolates",
   "business": "Haigh's Chocolates",
   "industry": "Chocolate Shop",
   "name": "Eric P.",
   "date": "May 2025",
   "stars": 5,
   "text": "They handled everything — I barely had to lift a finger",
   "label": "3D Non-Lit Letters on Backboard",
   "type_id": "3d-nonlit-backboard",
   "img": "https://cdn.shopify.com/s/files/1/0929/6606/0311/files/cs-060.webp?v=1791362137",
   "w": 500,
   "h": 500,
   "alt": "3D Non-Lit Letters on Backboard sign photo from customer Eric P.",
   "tags": [
    "3D Non-Lit Letters on Backboard",
    "Non-Lit",
    "Backboard"
   ],
   "about": "Dimensional letters on a custom backboard in metal, wood or painted finishes. Easy to install anywhere.",
   "hl": [],
   "g": "3d-non-lit-letters-on-backboard",
   "b": "food",
   "rel": [
    "RdgVv2OqQg",
    "OOQEcRU1yn",
    "AMXMzUJF-k"
   ]
  },
  {
   "id": "NM7cWKLrNw",
   "title": "Infinite Beauty Palace",
   "business": "Infinite Beauty Palace",
   "industry": "Beauty",
   "name": "Rebecca M.",
   "date": "May 2025",
   "stars": 5,
   "text": "The sign looks sharp and modern — exactly what we were going for",
   "label": "3D Metal Non-Lit Letters",
   "type_id": "3d-metal-nonlit",
   "img": "https://cdn.shopify.com/s/files/1/0929/6606/0311/files/cs-061.webp?v=1791362142",
   "w": 500,
   "h": 500,
   "alt": "3D Metal Non-Lit Letters sign photo from customer Rebecca M.",
   "tags": [
    "3D Metal Non-Lit Letters",
    "Non-Lit",
    "3D Metal"
   ],
   "about": "Brushed, polished or painted metal letters with real depth. No wiring, no maintenance.",
   "hl": [
    "Matched expectations"
   ],
   "g": "3d-metal-non-lit-letters",
   "b": "beauty",
   "rel": [
    "WBniW_7kXq",
    "wI7PnRISP5",
    "_EPSeNGoQD"
   ]
  },
  {
   "id": "I8R31t4zcQ",
   "title": "Dayi Nails",
   "business": "Dayi Nails",
   "industry": "Nail Salon",
   "name": "Angela C.",
   "date": "May 2025",
   "stars": 5,
   "text": "Turned out better than what I had in my head",
   "label": "2D Metal Letters",
   "type_id": "metal-2d",
   "img": "https://cdn.shopify.com/s/files/1/0929/6606/0311/files/cs-062.webp?v=1791362148",
   "w": 500,
   "h": 500,
   "alt": "2D Metal Letters sign photo from customer Angela C.",
   "tags": [
    "2D Metal Letters",
    "Non-Lit",
    "Metal"
   ],
   "about": "Laser-cut logos and lettering in slim 2mm or 5mm metal. Precise, flat and built to last.",
   "hl": [],
   "g": "2d-metal-letters",
   "b": "beauty",
   "rel": [
    "I_9T93hutuv",
    "96lDXjbjhpA",
    "jvagL1_NUp"
   ]
  },
  {
   "id": "jlkPC_Qjz_",
   "title": "Serene Radiance Esthetics",
   "business": "Serene Radiance Esthetics",
   "industry": "Esthetics",
   "name": "Stephanie R.",
   "date": "Apr 2025",
   "stars": 5,
   "text": "No pushy sales just honest advice and a really solid result",
   "label": "3D Acrylic Non-Lit Letters",
   "type_id": "3d-acrylic-nonlit",
   "img": "https://cdn.shopify.com/s/files/1/0929/6606/0311/files/cs-063.webp?v=1791362153",
   "w": 500,
   "h": 500,
   "alt": "3D Acrylic Non-Lit Letters sign photo from customer Stephanie R.",
   "tags": [
    "3D Acrylic Non-Lit Letters",
    "Non-Lit",
    "3D Acrylic"
   ],
   "about": "Lightweight, colorful letters and logos in layered or flat finishes. Ideal for interiors.",
   "hl": [
    "Quality & finish"
   ],
   "g": "3d-acrylic-non-lit-letters",
   "b": "beauty",
   "rel": [
    "_hoSdKdcfs",
    "HfsVqObAzH",
    "7kzKeS9nSLS"
   ]
  },
  {
   "id": "ZoxB5GyUtD",
   "title": "I Feel Pretty",
   "business": "I Feel Pretty",
   "industry": "Hair & Makeup",
   "name": "Melissa N.",
   "date": "Apr 2025",
   "stars": 4,
   "text": "Good pricing great communication and a great final product",
   "label": "3D Acrylic Non-Lit Letters",
   "type_id": "3d-acrylic-nonlit",
   "img": "https://cdn.shopify.com/s/files/1/0929/6606/0311/files/cs-064.webp?v=1791362158",
   "w": 500,
   "h": 500,
   "alt": "3D Acrylic Non-Lit Letters sign photo from customer Melissa N.",
   "tags": [
    "3D Acrylic Non-Lit Letters",
    "Non-Lit",
    "3D Acrylic"
   ],
   "about": "Lightweight, colorful letters and logos in layered or flat finishes. Ideal for interiors.",
   "hl": [
    "Customer service"
   ],
   "g": "3d-acrylic-non-lit-letters",
   "b": "beauty",
   "rel": [
    "HfsVqObAzH",
    "7kzKeS9nSLS",
    "KmgtExfHZ_"
   ]
  },
  {
   "id": "yM7iwtYt_KM",
   "title": "Eye Consultants and Surgeons of Arizona",
   "business": "Eye Consultants and Surgeons of Arizona",
   "industry": "Eye Care",
   "name": "Kevin A.",
   "date": "Apr 2025",
   "stars": 5,
   "text": "Honestly I thought signs were just signs until I saw how much this one elevated our place",
   "label": "3D Non-Lit Letters on Backboard",
   "type_id": "3d-nonlit-backboard",
   "img": "https://cdn.shopify.com/s/files/1/0929/6606/0311/files/cs-065.webp?v=1791362164",
   "w": 492,
   "h": 500,
   "alt": "3D Non-Lit Letters on Backboard sign photo from customer Kevin A.",
   "tags": [
    "3D Non-Lit Letters on Backboard",
    "Non-Lit",
    "Backboard"
   ],
   "about": "Dimensional letters on a custom backboard in metal, wood or painted finishes. Easy to install anywhere.",
   "hl": [],
   "g": "3d-non-lit-letters-on-backboard",
   "b": "health",
   "rel": [
    "dnPI_nmAsP",
    "OhqsdlMUWNd",
    "Dww8J0OKng"
   ]
  },
  {
   "id": "gXNm6y3ufY",
   "title": "Green Bear Solutions",
   "business": "Green Bear Solutions",
   "industry": "",
   "name": "Heather H.",
   "date": "Mar 2025",
   "stars": 5,
   "text": "The custom sign matches our branding perfectly. Nailed it",
   "label": "3D Metal Backlit Letters",
   "type_id": "3d-metal-backlit-letters",
   "img": "https://cdn.shopify.com/s/files/1/0929/6606/0311/files/cs-066.webp?v=1791362169",
   "w": 500,
   "h": 500,
   "alt": "3D Metal Backlit Letters sign photo from customer Heather H.",
   "tags": [
    "3D Metal Backlit Letters",
    "Illuminated",
    "3D Metal"
   ],
   "about": "Fabricated metal letters with an even halo glow on the wall behind. Premium, modern and easy to read.",
   "hl": [],
   "g": "3d-metal-backlit-letters",
   "b": "other",
   "rel": [
    "kWdZ7Pe0XM",
    "3cleXOnqho",
    "lVD73SKm00"
   ]
  },
  {
   "id": "JYeZ8z3RFL",
   "title": "Oxford Farm Kennels",
   "business": "Oxford Farm Kennels",
   "industry": "Kennels",
   "name": "Brian W.",
   "date": "Mar 2025",
   "stars": 5,
   "text": "They kept in touch the whole time which made it super easy to trust the process",
   "label": "Projecting Sign",
   "type_id": "light-box-double",
   "img": "https://cdn.shopify.com/s/files/1/0929/6606/0311/files/cs-067.webp?v=1791362175",
   "w": 500,
   "h": 500,
   "alt": "Projecting Sign sign photo from customer Brian W.",
   "tags": [
    "Projecting Sign",
    "Illuminated",
    "Light Box"
   ],
   "about": "Projects from the wall so pedestrians can see it from both directions. Square, round or custom shapes.",
   "hl": [],
   "g": "projecting-sign",
   "b": "pets",
   "rel": [
    "CKQ0OnLGuQ",
    "AZmm7zcQ2",
    "iwpuf9DArY"
   ]
  },
  {
   "id": "fu7oflBzzm",
   "title": "Earthly Body",
   "business": "Earthly Body",
   "industry": "",
   "name": "Joshua S.",
   "date": "Feb 2025",
   "stars": 5,
   "text": "I asked for some changes mid way and they handled it without any drama",
   "label": "3D Metal Backlit Letters",
   "type_id": "3d-metal-backlit-letters",
   "img": "https://cdn.shopify.com/s/files/1/0929/6606/0311/files/cs-068.webp?v=1791362180",
   "w": 500,
   "h": 500,
   "alt": "3D Metal Backlit Letters sign photo from customer Joshua S.",
   "tags": [
    "3D Metal Backlit Letters",
    "Illuminated",
    "3D Metal"
   ],
   "about": "Fabricated metal letters with an even halo glow on the wall behind. Premium, modern and easy to read.",
   "hl": [],
   "g": "3d-metal-backlit-letters",
   "b": "other",
   "rel": [
    "lVD73SKm00",
    "JY6F3KCgcd",
    "onGpCeTRGA"
   ]
  },
  {
   "id": "81pYYXGcHP",
   "title": "Antojitos",
   "business": "Antojitos",
   "industry": "",
   "name": "Rachel A.",
   "date": "Jan 2025",
   "stars": 5,
   "text": "Very happy with how it turned out. The font colors and spacing were all spot on",
   "label": "3D Acrylic Non-Lit Letters",
   "type_id": "3d-acrylic-nonlit",
   "img": "https://cdn.shopify.com/s/files/1/0929/6606/0311/files/cs-069.webp?v=1791362186",
   "w": 500,
   "h": 500,
   "alt": "3D Acrylic Non-Lit Letters sign photo from customer Rachel A.",
   "tags": [
    "3D Acrylic Non-Lit Letters",
    "Non-Lit",
    "3D Acrylic"
   ],
   "about": "Lightweight, colorful letters and logos in layered or flat finishes. Ideal for interiors.",
   "hl": [
    "Quality & finish"
   ],
   "g": "3d-acrylic-non-lit-letters",
   "b": "other",
   "rel": [
    "xsJq4XvV4L",
    "C6LAj9rHzh",
    "3a3edjYAWg"
   ]
  },
  {
   "id": "WBniW_7kXq",
   "title": "Frenchy",
   "business": "Frenchy",
   "industry": "Drinks & Food",
   "name": "Christopher Y.",
   "date": "Jan 2025",
   "stars": 5,
   "text": "I didnt realize how outdated our old signage looked until this one went up",
   "label": "3D Metal Non-Lit Letters",
   "type_id": "3d-metal-nonlit",
   "img": "https://cdn.shopify.com/s/files/1/0929/6606/0311/files/cs-070.webp?v=1791362191",
   "w": 500,
   "h": 500,
   "alt": "3D Metal Non-Lit Letters sign photo from customer Christopher Y.",
   "tags": [
    "3D Metal Non-Lit Letters",
    "Non-Lit",
    "3D Metal"
   ],
   "about": "Brushed, polished or painted metal letters with real depth. No wiring, no maintenance.",
   "hl": [],
   "g": "3d-metal-non-lit-letters",
   "b": "food",
   "rel": [
    "NM7cWKLrNw",
    "wI7PnRISP5",
    "_EPSeNGoQD"
   ]
  },
  {
   "id": "TuuEs0Jawu",
   "title": "Rayz Beauty",
   "business": "Rayz Beauty",
   "industry": "Beauty",
   "name": "Elizabeth H.",
   "date": "Dec 2024",
   "stars": 5,
   "text": "People literally started stopping in just to ask who did our sign",
   "label": "3D Metal Backlit Letters",
   "type_id": "3d-metal-backlit-letters",
   "img": "https://cdn.shopify.com/s/files/1/0929/6606/0311/files/cs-071.webp?v=1791362197",
   "w": 500,
   "h": 500,
   "alt": "3D Metal Backlit Letters sign photo from customer Elizabeth H.",
   "tags": [
    "3D Metal Backlit Letters",
    "Illuminated",
    "3D Metal"
   ],
   "about": "Fabricated metal letters with an even halo glow on the wall behind. Premium, modern and easy to read.",
   "hl": [],
   "g": "3d-metal-backlit-letters",
   "b": "beauty",
   "rel": [
    "r6AIJ2ZjP2",
    "7HlLePBkRH",
    "OBLhjKMhuU"
   ]
  },
  {
   "id": "Q7n3zgXKIw",
   "title": "Space Bar",
   "business": "Space Bar",
   "industry": "Bar",
   "name": "Andrew W.",
   "date": "Dec 2024",
   "stars": 5,
   "text": "I love that the sign looks good both during the day and lit up at night",
   "label": "Light Box Sign",
   "type_id": "light-box-single",
   "img": "https://cdn.shopify.com/s/files/1/0929/6606/0311/files/cs-072.webp?v=1791362203",
   "w": 500,
   "h": 500,
   "alt": "Light Box Sign sign photo from customer Andrew W.",
   "tags": [
    "Light Box Sign",
    "Illuminated",
    "Light Box"
   ],
   "about": "A wall-mounted illuminated cabinet that lights your entire logo evenly. Simple, bright and cost-effective.",
   "hl": [],
   "g": "light-box-sign",
   "b": "food",
   "rel": [
    "AMXMzUJF-k",
    "3fHTrWxlZs",
    "1jaEgEoS2k"
   ]
  },
  {
   "id": "Jo8EZNzc-T",
   "title": "Nicole L.’s 3D Acrylic Non-Lit Letters",
   "business": "",
   "industry": "",
   "name": "Nicole L.",
   "date": "Nov 2024",
   "stars": 5,
   "text": "They helped with everything from layout to sizing. I didnt feel lost in the process",
   "label": "3D Acrylic Non-Lit Letters",
   "type_id": "3d-acrylic-nonlit",
   "img": "https://cdn.shopify.com/s/files/1/0929/6606/0311/files/cs-073.webp?v=1791362208",
   "w": 500,
   "h": 500,
   "alt": "3D Acrylic Non-Lit Letters sign photo from customer Nicole L.",
   "tags": [
    "3D Acrylic Non-Lit Letters",
    "Non-Lit",
    "3D Acrylic"
   ],
   "about": "Lightweight, colorful letters and logos in layered or flat finishes. Ideal for interiors.",
   "hl": [],
   "g": "3d-acrylic-non-lit-letters",
   "b": "other",
   "rel": [
    "ZoxB5GyUtD",
    "81pYYXGcHP",
    "0V-XNsu89W"
   ]
  },
  {
   "id": "V-48u5pTF-",
   "title": "Matthew C.’s 2D Metal Letters",
   "business": "",
   "industry": "",
   "name": "Matthew C.",
   "date": "Nov 2024",
   "stars": 5,
   "text": "",
   "label": "2D Metal Letters",
   "type_id": "metal-2d",
   "img": "https://cdn.shopify.com/s/files/1/0929/6606/0311/files/cs-074.webp?v=1791362213",
   "w": 500,
   "h": 500,
   "alt": "2D Metal Letters sign photo from customer Matthew C.",
   "tags": [
    "2D Metal Letters",
    "Non-Lit",
    "Metal"
   ],
   "about": "Laser-cut logos and lettering in slim 2mm or 5mm metal. Precise, flat and built to last.",
   "hl": [],
   "g": "2d-metal-letters",
   "b": "other",
   "rel": [
    "juVxOxrTlt",
    "zOKKX_uQwF",
    "I_9T93hutuv"
   ]
  },
  {
   "id": "0V-XNsu89W",
   "title": "Meraki Beaute Bar",
   "business": "Meraki Beaute Bar",
   "industry": "Beauty Bar",
   "name": "Brittany G.",
   "date": "Oct 2024",
   "stars": 5,
   "text": "Ive already recommended you to two friends who run local businesses",
   "label": "3D Acrylic Non-Lit Letters",
   "type_id": "3d-acrylic-nonlit",
   "img": "https://cdn.shopify.com/s/files/1/0929/6606/0311/files/cs-075.webp?v=1791362220",
   "w": 500,
   "h": 498,
   "alt": "3D Acrylic Non-Lit Letters sign photo from customer Brittany G.",
   "tags": [
    "3D Acrylic Non-Lit Letters",
    "Non-Lit",
    "3D Acrylic"
   ],
   "about": "Lightweight, colorful letters and logos in layered or flat finishes. Ideal for interiors.",
   "hl": [
    "Would recommend"
   ],
   "g": "3d-acrylic-non-lit-letters",
   "b": "beauty",
   "rel": [
    "Jo8EZNzc-T",
    "_hoSdKdcfs",
    "HfsVqObAzH"
   ]
  },
  {
   "id": "Tp_ZfJa6yA",
   "title": "Daniel T.’s Light Box Sign",
   "business": "",
   "industry": "",
   "name": "Daniel T.",
   "date": "Oct 2024",
   "stars": 4,
   "text": "The new sign helped our business look way more established. It really matters",
   "label": "Light Box Sign",
   "type_id": "light-box-single",
   "img": "https://cdn.shopify.com/s/files/1/0929/6606/0311/files/cs-076.webp?v=1791362225",
   "w": 500,
   "h": 500,
   "alt": "Light Box Sign sign photo from customer Daniel T.",
   "tags": [
    "Light Box Sign",
    "Illuminated",
    "Light Box"
   ],
   "about": "A wall-mounted illuminated cabinet that lights your entire logo evenly. Simple, bright and cost-effective.",
   "hl": [],
   "g": "light-box-sign",
   "b": "other",
   "rel": [
    "4NXsaFGgW",
    "LH-KsoMMh",
    "pGJRyXZ5y"
   ]
  },
  {
   "id": "wI7PnRISP5",
   "title": "Peralta Associates & Defense",
   "business": "Peralta Associates & Defense",
   "industry": "",
   "name": "Lauren M.",
   "date": "Sep 2024",
   "stars": 5,
   "text": "The install crew was on time polite and quick. Super smooth process",
   "label": "3D Metal Non-Lit Letters",
   "type_id": "3d-metal-nonlit",
   "img": "https://cdn.shopify.com/s/files/1/0929/6606/0311/files/cs-077.webp?v=1791362230",
   "w": 500,
   "h": 500,
   "alt": "3D Metal Non-Lit Letters sign photo from customer Lauren M.",
   "tags": [
    "3D Metal Non-Lit Letters",
    "Non-Lit",
    "3D Metal"
   ],
   "about": "Brushed, polished or painted metal letters with real depth. No wiring, no maintenance.",
   "hl": [
    "Installation"
   ],
   "g": "3d-metal-non-lit-letters",
   "b": "other",
   "rel": [
    "WBniW_7kXq",
    "_EPSeNGoQD",
    "NM7cWKLrNw"
   ]
  },
  {
   "id": "AZmm7zcQ2",
   "title": "Joseph H.’s Projecting Sign",
   "business": "",
   "industry": "",
   "name": "Joseph H.",
   "date": "Aug 2024",
   "stars": 5,
   "text": "We wanted something bold but simple. They totally got what we meant",
   "label": "Projecting Sign",
   "type_id": "light-box-double",
   "img": "https://cdn.shopify.com/s/files/1/0929/6606/0311/files/cs-078.webp?v=1791362236",
   "w": 500,
   "h": 500,
   "alt": "Projecting Sign sign photo from customer Joseph H.",
   "tags": [
    "Projecting Sign",
    "Illuminated",
    "Light Box"
   ],
   "about": "Projects from the wall so pedestrians can see it from both directions. Square, round or custom shapes.",
   "hl": [],
   "g": "projecting-sign",
   "b": "other",
   "rel": [
    "hyWsr3dT1w",
    "CKQ0OnLGuQ",
    "JYeZ8z3RFL"
   ]
  },
  {
   "id": "juVxOxrTlt",
   "title": "Megan W.’s 2D Metal Letters",
   "business": "",
   "industry": "",
   "name": "Megan W.",
   "date": "Aug 2024",
   "stars": 5,
   "text": "",
   "label": "2D Metal Letters",
   "type_id": "metal-2d",
   "img": "https://cdn.shopify.com/s/files/1/0929/6606/0311/files/cs-079.webp?v=1791362242",
   "w": 500,
   "h": 500,
   "alt": "2D Metal Letters sign photo from customer Megan W.",
   "tags": [
    "2D Metal Letters",
    "Non-Lit",
    "Metal"
   ],
   "about": "Laser-cut logos and lettering in slim 2mm or 5mm metal. Precise, flat and built to last.",
   "hl": [],
   "g": "2d-metal-letters",
   "b": "other",
   "rel": [
    "9fNxcBuZus",
    "I8R31t4zcQ",
    "V-48u5pTF-"
   ]
  },
  {
   "id": "jQeZqCjf3M",
   "title": "O2 Fitness",
   "business": "O2 Fitness",
   "industry": "Fitness",
   "name": "William J.",
   "date": "Jul 2024",
   "stars": 5,
   "text": "Its amazing how much difference a good sign makes. Our storefront finally looks the part",
   "label": "3D Metal Backlit Letters",
   "type_id": "3d-metal-backlit-letters",
   "img": "https://cdn.shopify.com/s/files/1/0929/6606/0311/files/cs-080.webp?v=1791362247",
   "w": 500,
   "h": 500,
   "alt": "3D Metal Backlit Letters sign photo from customer William J.",
   "tags": [
    "3D Metal Backlit Letters",
    "Illuminated",
    "3D Metal"
   ],
   "about": "Fabricated metal letters with an even halo glow on the wall behind. Premium, modern and easy to read.",
   "hl": [],
   "g": "3d-metal-backlit-letters",
   "b": "pets",
   "rel": [
    "6mE6NIV03",
    "HLwa3Bdd53",
    "HXGuuoRTi4"
   ]
  },
  {
   "id": "iwpuf9DArY",
   "title": "Karen's Kabana",
   "business": "Karen's Kabana",
   "industry": "",
   "name": "Sarah T.",
   "date": "Jul 2024",
   "stars": 5,
   "text": "From the initial concept to the final install the whole experience was easy and stress free",
   "label": "Projecting Sign",
   "type_id": "light-box-double",
   "img": "https://cdn.shopify.com/s/files/1/0929/6606/0311/files/cs-081.webp?v=1791362252",
   "w": 500,
   "h": 500,
   "alt": "Projecting Sign sign photo from customer Sarah T.",
   "tags": [
    "Projecting Sign",
    "Illuminated",
    "Light Box"
   ],
   "about": "Projects from the wall so pedestrians can see it from both directions. Square, round or custom shapes.",
   "hl": [
    "Installation"
   ],
   "g": "projecting-sign",
   "b": "other",
   "rel": [
    "AZmm7zcQ2",
    "1jaEgEoS2k",
    "JpsTv_iuxRr"
   ]
  },
  {
   "id": "2VYQJ32Vbk",
   "title": "JamBox Sandwich Shop",
   "business": "JamBox Sandwich Shop",
   "industry": "Sandwich Shop",
   "name": "Emily W.",
   "date": "Jun 2024",
   "stars": 5,
   "text": "Honestly we get compliments on our sign all the time. It really stands out day and night",
   "label": "Raceway-Mounted Letters",
   "type_id": "3d-acrylic-lit-backboard",
   "img": "https://cdn.shopify.com/s/files/1/0929/6606/0311/files/cs-083.webp?v=1791362259",
   "w": 500,
   "h": 500,
   "alt": "Raceway-Mounted Letters sign photo from customer Emily W.",
   "tags": [
    "Raceway-Mounted Letters",
    "Illuminated",
    "3D Acrylic"
   ],
   "about": "Lit letters set on a backboard or raceway, giving uneven walls a clean, framed illuminated look.",
   "hl": [],
   "g": "raceway-mounted-letters",
   "b": "food",
   "rel": [
    "HfsVqObAzH",
    "Mz0k0No6mY",
    "FayaHlhvCv"
   ]
  },
  {
   "id": "wYh-HlKAUz",
   "title": "Mauck Show Hogs",
   "business": "Mauck Show Hogs",
   "industry": "",
   "name": "John A.",
   "date": "May 2024",
   "stars": 5,
   "text": "Weve worked with a few sign companies before — this one was by far the easiest and most professional",
   "label": "3D Acrylic Front Lit Letters",
   "type_id": "3d-acrylic-lit-letters",
   "img": "https://cdn.shopify.com/s/files/1/0929/6606/0311/files/cs-084.webp?v=1791362264",
   "w": 281,
   "h": 500,
   "alt": "3D Acrylic Front Lit Letters sign photo from customer John A.",
   "tags": [
    "3D Acrylic Front Lit Letters",
    "Illuminated",
    "3D Acrylic"
   ],
   "about": "Dimensional letters with glowing faces, lit edges or a soft halo. Crisp by day, bold after dark.",
   "hl": [
    "Customer service"
   ],
   "g": "3d-acrylic-front-lit-letters",
   "b": "other",
   "rel": [
    "Mz0k0No6mY",
    "FayaHlhvCv",
    "Am6GnHO2Zt"
   ]
  },
  {
   "id": "zOKKX_uQwF",
   "title": "Ashley M.’s 2D Metal Letters",
   "business": "",
   "industry": "Makeup Salon",
   "name": "Ashley M.",
   "date": "May 2024",
   "stars": 5,
   "text": "Turnaround time was fast pricing was fair and the sign looks great. Would definitely recommend",
   "label": "2D Metal Letters",
   "type_id": "metal-2d",
   "img": "https://cdn.shopify.com/s/files/1/0929/6606/0311/files/cs-085.webp?v=1791362270",
   "w": 375,
   "h": 500,
   "alt": "2D Metal Letters sign photo from customer Ashley M.",
   "tags": [
    "2D Metal Letters",
    "Non-Lit",
    "Metal"
   ],
   "about": "Laser-cut logos and lettering in slim 2mm or 5mm metal. Precise, flat and built to last.",
   "hl": [
    "Delivery",
    "Would recommend"
   ],
   "g": "2d-metal-letters",
   "b": "beauty",
   "rel": [
    "jvagL1_NUp",
    "9fNxcBuZus",
    "I8R31t4zcQ"
   ]
  },
  {
   "id": "RdgVv2OqQg",
   "title": "GeneTech Diagnostics",
   "business": "GeneTech Diagnostics",
   "industry": "Diagnostics",
   "name": "James T.",
   "date": "Apr 2024",
   "stars": 5,
   "text": "Our new office sign gives a really solid first impression. Clean modern and well made",
   "label": "3D Non-Lit Letters on Backboard",
   "type_id": "3d-nonlit-backboard",
   "img": "https://cdn.shopify.com/s/files/1/0929/6606/0311/files/cs-086.webp?v=1791362275",
   "w": 500,
   "h": 500,
   "alt": "3D Non-Lit Letters on Backboard sign photo from customer James T.",
   "tags": [
    "3D Non-Lit Letters on Backboard",
    "Non-Lit",
    "Backboard"
   ],
   "about": "Dimensional letters on a custom backboard in metal, wood or painted finishes. Easy to install anywhere.",
   "hl": [
    "Quality & finish"
   ],
   "g": "3d-non-lit-letters-on-backboard",
   "b": "other",
   "rel": [
    "A0HNd4ni2Y",
    "yM7iwtYt_KM",
    "OOQEcRU1yn"
   ]
  },
  {
   "id": "OOQEcRU1yn",
   "title": "Pillar Performance",
   "business": "Pillar Performance",
   "industry": "",
   "name": "Amanda B.",
   "date": "Apr 2024",
   "stars": 5,
   "text": "I wasnt sure what type of sign would work best but they helped us pick the right one — and it looks awesome",
   "label": "3D Non-Lit Letters on Backboard",
   "type_id": "3d-nonlit-backboard",
   "img": "https://cdn.shopify.com/s/files/1/0929/6606/0311/files/cs-087.webp?v=1791362280",
   "w": 375,
   "h": 500,
   "alt": "3D Non-Lit Letters on Backboard sign photo from customer Amanda B.",
   "tags": [
    "3D Non-Lit Letters on Backboard",
    "Non-Lit",
    "Backboard"
   ],
   "about": "Dimensional letters on a custom backboard in metal, wood or painted finishes. Easy to install anywhere.",
   "hl": [],
   "g": "3d-non-lit-letters-on-backboard",
   "b": "other",
   "rel": [
    "yM7iwtYt_KM",
    "RdgVv2OqQg",
    "AMXMzUJF-k"
   ]
  },
  {
   "id": "AMXMzUJF-k",
   "title": "Graceful Wellness",
   "business": "Graceful Wellness",
   "industry": "Wellness",
   "name": "David S.",
   "date": "Mar 2024",
   "stars": 5,
   "text": "Weve already had customers say they noticed us because of the new sign. Cant ask for more than that",
   "label": "3D Non-Lit Letters on Backboard",
   "type_id": "3d-nonlit-backboard",
   "img": "https://cdn.shopify.com/s/files/1/0929/6606/0311/files/cs-088.webp?v=1791362286",
   "w": 500,
   "h": 500,
   "alt": "3D Non-Lit Letters on Backboard sign photo from customer David S.",
   "tags": [
    "3D Non-Lit Letters on Backboard",
    "Non-Lit",
    "Backboard"
   ],
   "about": "Dimensional letters on a custom backboard in metal, wood or painted finishes. Easy to install anywhere.",
   "hl": [],
   "g": "3d-non-lit-letters-on-backboard",
   "b": "health",
   "rel": [
    "RdgVv2OqQg",
    "OOQEcRU1yn",
    "MpB2a1rTIw"
   ]
  },
  {
   "id": "3fHTrWxlZs",
   "title": "InTouch M. Spa",
   "business": "InTouch M. Spa",
   "industry": "Spa",
   "name": "Jessica W.",
   "date": "Feb 2024",
   "stars": 5,
   "text": "Super happy with how our sign came out. It was easy working with your team — everything was smooth from start to finish",
   "label": "3D Metal Backlit Letters",
   "type_id": "3d-metal-backlit-letters",
   "img": "https://cdn.shopify.com/s/files/1/0929/6606/0311/files/cs-089.webp?v=1791362291",
   "w": 375,
   "h": 500,
   "alt": "3D Metal Backlit Letters sign photo from customer Jessica W.",
   "tags": [
    "3D Metal Backlit Letters",
    "Illuminated",
    "3D Metal"
   ],
   "about": "Fabricated metal letters with an even halo glow on the wall behind. Premium, modern and easy to read.",
   "hl": [
    "Quality & finish",
    "Customer service"
   ],
   "g": "3d-metal-backlit-letters",
   "b": "other",
   "rel": [
    "CFdTomC1Bt",
    "BjapyJbI-Y",
    "gXNm6y3ufY"
   ]
  },
  {
   "id": "1jaEgEoS2k",
   "title": "The Lotus Center",
   "business": "The Lotus Center",
   "industry": "Health & Care",
   "name": "Michael J.",
   "date": "Jan 2024",
   "stars": 5,
   "text": "The sign turned out perfect — exactly what we pictured. It gave our shop the professional edge it needed",
   "label": "Projecting Sign",
   "type_id": "light-box-double",
   "img": "https://cdn.shopify.com/s/files/1/0929/6606/0311/files/cs-090.webp?v=1791362296",
   "w": 500,
   "h": 500,
   "alt": "Projecting Sign sign photo from customer Michael J.",
   "tags": [
    "Projecting Sign",
    "Illuminated",
    "Light Box"
   ],
   "about": "Projects from the wall so pedestrians can see it from both directions. Square, round or custom shapes.",
   "hl": [
    "Customer service",
    "Matched expectations"
   ],
   "g": "projecting-sign",
   "b": "health",
   "rel": [
    "hyWsr3dT1w",
    "CKQ0OnLGuQ",
    "JYeZ8z3RFL"
   ]
  },
  {
   "id": "-nRyWiPI3",
   "title": "Hearing Aid Center",
   "business": "Hearing Aid Center",
   "industry": "Healthcare",
   "name": "Shawgy F.",
   "date": "Aug 2026",
   "stars": 5,
   "text": "Easy to install, the colors come out great",
   "label": "Custom Sign",
   "type_id": null,
   "img": "https://cdn.shopify.com/s/files/1/0929/6606/0311/files/cs-001.webp?v=1791361818",
   "w": 500,
   "h": 375,
   "alt": "Custom Sign sign photo from customer Shawgy F.",
   "tags": [
    "Custom Sign"
   ],
   "about": "A custom sign made, fabricated and shipped by Signage.inc.",
   "hl": [
    "Installation",
    "Quality & finish"
   ],
   "g": "other",
   "b": "health",
   "rel": [
    "LH-KsoMMh",
    "pGJRyXZ5y",
    "4NXsaFGgW"
   ]
  },
  {
   "id": "4NXsaFGgW",
   "title": "Crossroads Live",
   "business": "Crossroads Live",
   "industry": "",
   "name": "Alexis P.",
   "date": "Apr 2026",
   "stars": 5,
   "text": "Easy to work with, and the sign arrived days before it was expected.",
   "label": "Custom Sign",
   "type_id": null,
   "img": "https://cdn.shopify.com/s/files/1/0929/6606/0311/files/cs-002.webp?v=1791361824",
   "w": 500,
   "h": 334,
   "alt": "Custom Sign sign photo from customer Alexis P.",
   "tags": [
    "Custom Sign"
   ],
   "about": "A custom sign made, fabricated and shipped by Signage.inc.",
   "hl": [
    "Delivery",
    "Customer service",
    "Matched expectations"
   ],
   "g": "other",
   "b": "other",
   "rel": [
    "pGJRyXZ5y",
    "-nRyWiPI3",
    "LH-KsoMMh"
   ]
  },
  {
   "id": "LH-KsoMMh",
   "title": "Sunrise",
   "business": "Sunrise",
   "industry": "",
   "name": "Diana B.",
   "date": "Mar 2026",
   "stars": 5,
   "text": "We love our sign. It was easy to install and exactly as we'd imagined! I would definitely recommend them.",
   "label": "Custom Sign",
   "type_id": null,
   "img": "https://cdn.shopify.com/s/files/1/0929/6606/0311/files/cs-003.webp?v=1791361829",
   "w": 248,
   "h": 500,
   "alt": "Custom Sign sign photo from customer Diana B.",
   "tags": [
    "Custom Sign"
   ],
   "about": "A custom sign made, fabricated and shipped by Signage.inc.",
   "hl": [
    "Installation",
    "Matched expectations",
    "Would recommend"
   ],
   "g": "other",
   "b": "other",
   "rel": [
    "-nRyWiPI3",
    "4NXsaFGgW",
    "pGJRyXZ5y"
   ]
  },
  {
   "id": "pGJRyXZ5y",
   "title": "Dennis S.’s Custom Sign",
   "business": "",
   "industry": "",
   "name": "Dennis S.",
   "date": "Nov 2025",
   "stars": 5,
   "text": "I’ll share an another pic as soon as it gets put up!",
   "label": "Custom Sign",
   "type_id": null,
   "img": "https://cdn.shopify.com/s/files/1/0929/6606/0311/files/cs-004.webp?v=1791361835",
   "w": 375,
   "h": 500,
   "alt": "Custom Sign sign photo from customer Dennis S.",
   "tags": [
    "Custom Sign"
   ],
   "about": "A custom sign made, fabricated and shipped by Signage.inc.",
   "hl": [],
   "g": "other",
   "b": "other",
   "rel": [
    "4NXsaFGgW",
    "LH-KsoMMh",
    "-nRyWiPI3"
   ]
  },
  {
   "id": "I_9T93hutuv",
   "title": "Artistry",
   "business": "Artistry",
   "industry": "Beauty & Skin",
   "name": "Lauren H.",
   "date": "Oct 2025",
   "stars": 5,
   "text": "metal is exactly like I asked for, thankyou will order more soon.",
   "label": "2D Metal Letters",
   "type_id": "metal-2d",
   "img": "https://cdn.shopify.com/s/files/1/0929/6606/0311/files/cs-005.webp?v=1791361840",
   "w": 500,
   "h": 500,
   "alt": "2D Metal Letters sign photo from customer Lauren H.",
   "tags": [
    "2D Metal Letters",
    "Non-Lit",
    "Metal"
   ],
   "about": "Laser-cut logos and lettering in slim 2mm or 5mm metal. Precise, flat and built to last.",
   "hl": [
    "Matched expectations",
    "Would order again"
   ],
   "g": "2d-metal-letters",
   "b": "beauty",
   "rel": [
    "juVxOxrTlt",
    "zOKKX_uQwF",
    "96lDXjbjhpA"
   ]
  },
  {
   "id": "JpsTv_iuxRr",
   "title": "Raj M.’s Projecting Sign",
   "business": "",
   "industry": "",
   "name": "Raj M.",
   "date": "Oct 2025",
   "stars": 5,
   "text": "",
   "label": "Projecting Sign",
   "type_id": "light-box-double",
   "img": "https://cdn.shopify.com/s/files/1/0929/6606/0311/files/cs-006.webp?v=1791361846",
   "w": 225,
   "h": 500,
   "alt": "Projecting Sign sign photo from customer Raj M.",
   "tags": [
    "Projecting Sign",
    "Illuminated",
    "Light Box"
   ],
   "about": "Projects from the wall so pedestrians can see it from both directions. Square, round or custom shapes.",
   "hl": [],
   "g": "projecting-sign",
   "b": "other",
   "rel": [
    "hyWsr3dT1w",
    "CKQ0OnLGuQ",
    "JYeZ8z3RFL"
   ]
  },
  {
   "id": "vhDDfsDZlb",
   "title": "Hart County Sheriff",
   "business": "Hart County Sheriff",
   "industry": "Law Enforcement",
   "name": "Matthew G.",
   "date": "Oct 2025",
   "stars": 4,
   "text": "Got my sign last week, and it’s flawless. The color and glow are perfect for our logo.",
   "label": "3D Metal Backlit Letters",
   "type_id": "3d-metal-backlit-letters",
   "img": "https://cdn.shopify.com/s/files/1/0929/6606/0311/files/cs-008.webp?v=1791361851",
   "w": 375,
   "h": 500,
   "alt": "3D Metal Backlit Letters sign photo from customer Matthew G.",
   "tags": [
    "3D Metal Backlit Letters",
    "Illuminated",
    "3D Metal"
   ],
   "about": "Fabricated metal letters with an even halo glow on the wall behind. Premium, modern and easy to read.",
   "hl": [
    "Quality & finish"
   ],
   "g": "3d-metal-backlit-letters",
   "b": "pro",
   "rel": [
    "oi0jgABJXW",
    "N79bpNoT6y",
    "v62DiEsFda"
   ]
  },
  {
   "id": "_hoSdKdcfs",
   "title": "Beauty Ink",
   "business": "Beauty Ink",
   "industry": "Beauty Salon",
   "name": "Ananya R.",
   "date": "Oct 2025",
   "stars": 5,
   "text": "Beautiful sign! Really enhances our wall",
   "label": "3D Acrylic Non-Lit Letters",
   "type_id": "3d-acrylic-nonlit",
   "img": "https://cdn.shopify.com/s/files/1/0929/6606/0311/files/cs-010.webp?v=1791361862",
   "w": 375,
   "h": 500,
   "alt": "3D Acrylic Non-Lit Letters sign photo from customer Ananya R.",
   "tags": [
    "3D Acrylic Non-Lit Letters",
    "Non-Lit",
    "3D Acrylic"
   ],
   "about": "Lightweight, colorful letters and logos in layered or flat finishes. Ideal for interiors.",
   "hl": [],
   "g": "3d-acrylic-non-lit-letters",
   "b": "beauty",
   "rel": [
    "Jo8EZNzc-T",
    "0V-XNsu89W",
    "HfsVqObAzH"
   ]
  },
  {
   "id": "HfsVqObAzH",
   "title": "Godlight",
   "business": "Godlight",
   "industry": "",
   "name": "Ethan B.",
   "date": "Oct 2025",
   "stars": 5,
   "text": "OMG, In loveee",
   "label": "3D Acrylic Non-Lit Letters",
   "type_id": "3d-acrylic-nonlit",
   "img": "https://cdn.shopify.com/s/files/1/0929/6606/0311/files/cs-011.webp?v=1791361868",
   "w": 375,
   "h": 500,
   "alt": "3D Acrylic Non-Lit Letters sign photo from customer Ethan B.",
   "tags": [
    "3D Acrylic Non-Lit Letters",
    "Non-Lit",
    "3D Acrylic"
   ],
   "about": "Lightweight, colorful letters and logos in layered or flat finishes. Ideal for interiors.",
   "hl": [],
   "g": "3d-acrylic-non-lit-letters",
   "b": "other",
   "rel": [
    "0V-XNsu89W",
    "_hoSdKdcfs",
    "7kzKeS9nSLS"
   ]
  },
  {
   "id": "Mz0k0No6mY",
   "title": "Bonbon",
   "business": "Bonbon",
   "industry": "",
   "name": "Aarav M.",
   "date": "Sep 2025",
   "stars": 5,
   "text": "The team was super helpful throughout the process.",
   "label": "3D Metal Backlit Letters",
   "type_id": "3d-metal-backlit-letters",
   "img": "https://cdn.shopify.com/s/files/1/0929/6606/0311/files/cs-014.webp?v=1791361884",
   "w": 375,
   "h": 500,
   "alt": "3D Metal Backlit Letters sign photo from customer Aarav M.",
   "tags": [
    "3D Metal Backlit Letters",
    "Illuminated",
    "3D Metal"
   ],
   "about": "Fabricated metal letters with an even halo glow on the wall behind. Premium, modern and easy to read.",
   "hl": [
    "Customer service"
   ],
   "g": "3d-metal-backlit-letters",
   "b": "other",
   "rel": [
    "6mE6NIV03",
    "HLwa3Bdd53",
    "HXGuuoRTi4"
   ]
  },
  {
   "id": "FayaHlhvCv",
   "title": "Neha B.’s 3D Metal Backlit Letters",
   "business": "",
   "industry": "",
   "name": "Neha B.",
   "date": "Sep 2025",
   "stars": 4,
   "text": "Good experience overall. The sign looks neat and durable. Worth the price for sure.",
   "label": "3D Metal Backlit Letters",
   "type_id": "3d-metal-backlit-letters",
   "img": "https://cdn.shopify.com/s/files/1/0929/6606/0311/files/cs-020.webp?v=1791361917",
   "w": 270,
   "h": 500,
   "alt": "3D Metal Backlit Letters sign photo from customer Neha B.",
   "tags": [
    "3D Metal Backlit Letters",
    "Illuminated",
    "3D Metal"
   ],
   "about": "Fabricated metal letters with an even halo glow on the wall behind. Premium, modern and easy to read.",
   "hl": [
    "Value"
   ],
   "g": "3d-metal-backlit-letters",
   "b": "other",
   "rel": [
    "q5kaHp-5iZ",
    "SKrZAjNNCH",
    "-7J9xLU2rP"
   ]
  },
  {
   "id": "Am6GnHO2Zt",
   "title": "GW",
   "business": "GW",
   "industry": "",
   "name": "Michael R.",
   "date": "Sep 2025",
   "stars": 5,
   "text": "Honestly, this turned out better than I imagined.",
   "label": "3D Metal Backlit Letters",
   "type_id": "3d-metal-backlit-letters",
   "img": "https://cdn.shopify.com/s/files/1/0929/6606/0311/files/cs-022.webp?v=1791361928",
   "w": 400,
   "h": 500,
   "alt": "3D Metal Backlit Letters sign photo from customer Michael R.",
   "tags": [
    "3D Metal Backlit Letters",
    "Illuminated",
    "3D Metal"
   ],
   "about": "Fabricated metal letters with an even halo glow on the wall behind. Premium, modern and easy to read.",
   "hl": [],
   "g": "3d-metal-backlit-letters",
   "b": "other",
   "rel": [
    "-7J9xLU2rP",
    "CFdTomC1Bt",
    "BjapyJbI-Y"
   ]
  },
  {
   "id": "-tr_a4HC1T5",
   "title": "Jessica A.’s Projecting Sign",
   "business": "",
   "industry": "",
   "name": "Jessica A.",
   "date": "Oct 2025",
   "stars": 5,
   "text": "In loveeee *_*",
   "label": "Projecting Sign",
   "type_id": "light-box-double",
   "img": "",
   "w": 0,
   "h": 0,
   "alt": "",
   "tags": [
    "Projecting Sign",
    "Illuminated",
    "Light Box"
   ],
   "about": "Projects from the wall so pedestrians can see it from both directions. Square, round or custom shapes.",
   "hl": [],
   "g": "projecting-sign",
   "b": "other",
   "rel": [
    "hyWsr3dT1w",
    "CKQ0OnLGuQ",
    "JYeZ8z3RFL"
   ]
  },
  {
   "id": "4M621OSA7Z",
   "title": "Lucas B.’s 3D Acrylic Non-Lit Letters",
   "business": "",
   "industry": "",
   "name": "Lucas B.",
   "date": "Jul 2025",
   "stars": 5,
   "text": "",
   "label": "3D Acrylic Non-Lit Letters",
   "type_id": "3d-acrylic-nonlit",
   "img": "",
   "w": 0,
   "h": 0,
   "alt": "",
   "tags": [
    "3D Acrylic Non-Lit Letters",
    "Non-Lit",
    "3D Acrylic"
   ],
   "about": "Lightweight, colorful letters and logos in layered or flat finishes. Ideal for interiors.",
   "hl": [],
   "g": "3d-acrylic-non-lit-letters",
   "b": "other",
   "rel": [
    "IF8e6JU6i1",
    "xsJq4XvV4L",
    "C6LAj9rHzh"
   ]
  },
  {
   "id": "XgRbj6Iz4ZA",
   "title": "Olivia M.’s Raceway-Mounted Letters",
   "business": "",
   "industry": "",
   "name": "Olivia M.",
   "date": "Jun 2025",
   "stars": 5,
   "text": "The size was perfect. They helped make sure it didnt overpower the storefront",
   "label": "Raceway-Mounted Letters",
   "type_id": "3d-acrylic-lit-backboard",
   "img": "",
   "w": 0,
   "h": 0,
   "alt": "",
   "tags": [
    "Raceway-Mounted Letters",
    "Illuminated",
    "3D Acrylic"
   ],
   "about": "Lit letters set on a backboard or raceway, giving uneven walls a clean, framed illuminated look.",
   "hl": [],
   "g": "raceway-mounted-letters",
   "b": "other",
   "rel": [
    "v62DiEsFda",
    "96lDXjbjhpA",
    "7kzKeS9nSLS"
   ]
  },
  {
   "id": "C5dJ8ybCyks",
   "title": "Mark L.’s Raceway-Mounted Letters",
   "business": "",
   "industry": "",
   "name": "Mark L.",
   "date": "Jun 2025",
   "stars": 5,
   "text": "tons of compliments from clients and even neighboring businesses",
   "label": "Raceway-Mounted Letters",
   "type_id": "3d-acrylic-lit-backboard",
   "img": "",
   "w": 0,
   "h": 0,
   "alt": "",
   "tags": [
    "Raceway-Mounted Letters",
    "Illuminated",
    "3D Acrylic"
   ],
   "about": "Lit letters set on a backboard or raceway, giving uneven walls a clean, framed illuminated look.",
   "hl": [],
   "g": "raceway-mounted-letters",
   "b": "other",
   "rel": [
    "96lDXjbjhpA",
    "7kzKeS9nSLS",
    "hyWsr3dT1w"
   ]
  },
  {
   "id": "Qbtdc4E6QND",
   "title": "Tyler B.’s 3D Non-Lit Letters on Backboard",
   "business": "",
   "industry": "",
   "name": "Tyler B.",
   "date": "Jun 2025",
   "stars": 5,
   "text": "Even our landlord said its the best looking sign,hehe",
   "label": "3D Non-Lit Letters on Backboard",
   "type_id": "3d-nonlit-backboard",
   "img": "",
   "w": 0,
   "h": 0,
   "alt": "",
   "tags": [
    "3D Non-Lit Letters on Backboard",
    "Non-Lit",
    "Backboard"
   ],
   "about": "Dimensional letters on a custom backboard in metal, wood or painted finishes. Easy to install anywhere.",
   "hl": [],
   "g": "3d-non-lit-letters-on-backboard",
   "b": "other",
   "rel": [
    "Dww8J0OKng",
    "A0HNd4ni2Y",
    "yM7iwtYt_KM"
   ]
  },
  {
   "id": "LDpbIG42n4W",
   "title": "Jason P.’s 3D Metal Backlit Letters",
   "business": "",
   "industry": "",
   "name": "Jason P.",
   "date": "Jun 2025",
   "stars": 5,
   "text": "The lighting looks awesome at night.",
   "label": "3D Metal Backlit Letters",
   "type_id": "3d-metal-backlit-letters",
   "img": "",
   "w": 0,
   "h": 0,
   "alt": "",
   "tags": [
    "3D Metal Backlit Letters",
    "Illuminated",
    "3D Metal"
   ],
   "about": "Fabricated metal letters with an even halo glow on the wall behind. Premium, modern and easy to read.",
   "hl": [],
   "g": "3d-metal-backlit-letters",
   "b": "other",
   "rel": [
    "JY6F3KCgcd",
    "onGpCeTRGA",
    "r6AIJ2ZjP2"
   ]
  },
  {
   "id": "6tdm_icv1Ul",
   "title": "Danielle P.’s 3D Metal Backlit Letters",
   "business": "",
   "industry": "",
   "name": "Danielle P.",
   "date": "Jun 2025",
   "stars": 5,
   "text": "It feels custom not cookie cutter. That was really important to us",
   "label": "3D Metal Backlit Letters",
   "type_id": "3d-metal-backlit-letters",
   "img": "",
   "w": 0,
   "h": 0,
   "alt": "",
   "tags": [
    "3D Metal Backlit Letters",
    "Illuminated",
    "3D Metal"
   ],
   "about": "Fabricated metal letters with an even halo glow on the wall behind. Premium, modern and easy to read.",
   "hl": [],
   "g": "3d-metal-backlit-letters",
   "b": "other",
   "rel": [
    "onGpCeTRGA",
    "r6AIJ2ZjP2",
    "7HlLePBkRH"
   ]
  },
  {
   "id": "xMmzPbz_Ae",
   "title": "Jonathan H.’s 3D Acrylic Front Lit Letters",
   "business": "",
   "industry": "",
   "name": "Jonathan H.",
   "date": "Jun 2025",
   "stars": 5,
   "text": "Weve gotten more foot traffic since we put the sign up. Legit",
   "label": "3D Acrylic Front Lit Letters",
   "type_id": "3d-acrylic-lit-letters",
   "img": "",
   "w": 0,
   "h": 0,
   "alt": "",
   "tags": [
    "3D Acrylic Front Lit Letters",
    "Illuminated",
    "3D Acrylic"
   ],
   "about": "Dimensional letters with glowing faces, lit edges or a soft halo. Crisp by day, bold after dark.",
   "hl": [],
   "g": "3d-acrylic-front-lit-letters",
   "b": "other",
   "rel": [
    "KmgtExfHZ_",
    "UCPhdPHu-3",
    "9fNxcBuZus"
   ]
  },
  {
   "id": "2ASA5-RLGO",
   "title": "Kimberly R.’s Projecting Sign",
   "business": "",
   "industry": "",
   "name": "Kimberly R.",
   "date": "Jun 2025",
   "stars": 5,
   "text": "They were so supportive",
   "label": "Projecting Sign",
   "type_id": "light-box-double",
   "img": "",
   "w": 0,
   "h": 0,
   "alt": "",
   "tags": [
    "Projecting Sign",
    "Illuminated",
    "Light Box"
   ],
   "about": "Projects from the wall so pedestrians can see it from both directions. Square, round or custom shapes.",
   "hl": [
    "Customer service"
   ],
   "g": "projecting-sign",
   "b": "other",
   "rel": [
    "AZmm7zcQ2",
    "iwpuf9DArY",
    "1jaEgEoS2k"
   ]
  },
  {
   "id": "ducO1FvV0H",
   "title": "Brandon P.’s Raceway-Mounted Letters",
   "business": "",
   "industry": "",
   "name": "Brandon P.",
   "date": "Jun 2025",
   "stars": 4,
   "text": "Definitely helped make our brand feel more premium",
   "label": "Raceway-Mounted Letters",
   "type_id": "3d-acrylic-lit-backboard",
   "img": "",
   "w": 0,
   "h": 0,
   "alt": "",
   "tags": [
    "Raceway-Mounted Letters",
    "Illuminated",
    "3D Acrylic"
   ],
   "about": "Lit letters set on a backboard or raceway, giving uneven walls a clean, framed illuminated look.",
   "hl": [
    "Quality & finish"
   ],
   "g": "raceway-mounted-letters",
   "b": "other",
   "rel": [
    "UCPhdPHu-3",
    "9fNxcBuZus",
    "RPDJITOFzM"
   ]
  },
  {
   "id": "5K0reNJG42D",
   "title": "Steven R.’s 3D Acrylic Front Lit Letters",
   "business": "",
   "industry": "",
   "name": "Steven R.",
   "date": "Jun 2025",
   "stars": 5,
   "text": "Ahora realmente se siente como parte del edificio, no solo pegado.",
   "label": "3D Acrylic Front Lit Letters",
   "type_id": "3d-acrylic-lit-letters",
   "img": "",
   "w": 0,
   "h": 0,
   "alt": "",
   "tags": [
    "3D Acrylic Front Lit Letters",
    "Illuminated",
    "3D Acrylic"
   ],
   "about": "Dimensional letters with glowing faces, lit edges or a soft halo. Crisp by day, bold after dark.",
   "hl": [],
   "g": "3d-acrylic-front-lit-letters",
   "b": "other",
   "rel": [
    "RPDJITOFzM",
    "hJFnmDGKho",
    "CrqmjEBhmZ"
   ]
  },
  {
   "id": "u10OsfIrrn",
   "title": "Christina W.’s Light Box Sign",
   "business": "",
   "industry": "",
   "name": "Christina W.",
   "date": "May 2025",
   "stars": 5,
   "text": "wanted something visible from the road and this one pops",
   "label": "Light Box Sign",
   "type_id": "light-box-single",
   "img": "",
   "w": 0,
   "h": 0,
   "alt": "",
   "tags": [
    "Light Box Sign",
    "Illuminated",
    "Light Box"
   ],
   "about": "A wall-mounted illuminated cabinet that lights your entire logo evenly. Simple, bright and cost-effective.",
   "hl": [],
   "g": "light-box-sign",
   "b": "other",
   "rel": [
    "CrqmjEBhmZ",
    "Q7n3zgXKIw",
    "Tp_ZfJa6yA"
   ]
  },
  {
   "id": "YJ_EPtgIg1",
   "title": "Amy C.’s 3D Acrylic Front Lit Letters",
   "business": "",
   "industry": "",
   "name": "Amy C.",
   "date": "May 2025",
   "stars": 5,
   "text": "exactly like mockup, love it",
   "label": "3D Acrylic Front Lit Letters",
   "type_id": "3d-acrylic-lit-letters",
   "img": "",
   "w": 0,
   "h": 0,
   "alt": "",
   "tags": [
    "3D Acrylic Front Lit Letters",
    "Illuminated",
    "3D Acrylic"
   ],
   "about": "Dimensional letters with glowing faces, lit edges or a soft halo. Crisp by day, bold after dark.",
   "hl": [
    "Mockup & customization",
    "Matched expectations"
   ],
   "g": "3d-acrylic-front-lit-letters",
   "b": "other",
   "rel": [
    "CrqmjEBhmZ",
    "IF8e6JU6i1",
    "xOVOppon6n"
   ]
  },
  {
   "id": "QCDXlF8YaI",
   "title": "Anthony G.’s 2D Metal Letters",
   "business": "",
   "industry": "",
   "name": "Anthony G.",
   "date": "May 2025",
   "stars": 5,
   "text": "love it",
   "label": "2D Metal Letters",
   "type_id": "metal-2d",
   "img": "",
   "w": 0,
   "h": 0,
   "alt": "",
   "tags": [
    "2D Metal Letters",
    "Non-Lit",
    "Metal"
   ],
   "about": "Laser-cut logos and lettering in slim 2mm or 5mm metal. Precise, flat and built to last.",
   "hl": [],
   "g": "2d-metal-letters",
   "b": "other",
   "rel": [
    "jvagL1_NUp",
    "9fNxcBuZus",
    "I8R31t4zcQ"
   ]
  },
  {
   "id": "FWRK8K-_SO",
   "title": "Thomas R.’s Push-Thru Sign",
   "business": "",
   "industry": "",
   "name": "Thomas R.",
   "date": "Apr 2025",
   "stars": 5,
   "text": "we went with a push thru sign and it looks high end, totally worth it",
   "label": "Push-Thru Sign",
   "type_id": "push-thru",
   "img": "",
   "w": 0,
   "h": 0,
   "alt": "",
   "tags": [
    "Push-Thru Sign",
    "Illuminated",
    "Light Box"
   ],
   "about": "Illuminated cabinet with letters and logos pushed through the face. Sharp contrast, strong presence.",
   "hl": [
    "Value"
   ],
   "g": "other",
   "b": "other",
   "rel": [
    "kVjEqjKk1F",
    "6mE6NIV03",
    "dnPI_nmAsP"
   ]
  },
  {
   "id": "OUqNObtUM80",
   "title": "Justin B.’s 2D Metal Letters",
   "business": "",
   "industry": "",
   "name": "Justin B.",
   "date": "Apr 2025",
   "stars": 5,
   "text": "",
   "label": "2D Metal Letters",
   "type_id": "metal-2d",
   "img": "",
   "w": 0,
   "h": 0,
   "alt": "",
   "tags": [
    "2D Metal Letters",
    "Non-Lit",
    "Metal"
   ],
   "about": "Laser-cut logos and lettering in slim 2mm or 5mm metal. Precise, flat and built to last.",
   "hl": [],
   "g": "2d-metal-letters",
   "b": "other",
   "rel": [
    "I8R31t4zcQ",
    "V-48u5pTF-",
    "juVxOxrTlt"
   ]
  },
  {
   "id": "mK2TqkfHRy",
   "title": "Robert M.’s 3D Metal Non-Lit Letters",
   "business": "",
   "industry": "",
   "name": "Robert M.",
   "date": "Jun 2024",
   "stars": 5,
   "text": "",
   "label": "3D Metal Non-Lit Letters",
   "type_id": "3d-metal-nonlit",
   "img": "",
   "w": 0,
   "h": 0,
   "alt": "",
   "tags": [
    "3D Metal Non-Lit Letters",
    "Non-Lit",
    "3D Metal"
   ],
   "about": "Brushed, polished or painted metal letters with real depth. No wiring, no maintenance.",
   "hl": [],
   "g": "3d-metal-non-lit-letters",
   "b": "other",
   "rel": [
    "WBniW_7kXq",
    "wI7PnRISP5",
    "_EPSeNGoQD"
   ]
  },
  {
   "id": "pUUhZhVzqW",
   "title": "Dennis G.’s Custom Sign",
   "business": "",
   "industry": "",
   "name": "Dennis G.",
   "date": "Sep 2026",
   "stars": 5,
   "text": "Great communication. Great turnout. Met my expectations",
   "label": "Custom Sign",
   "type_id": null,
   "img": "",
   "w": 0,
   "h": 0,
   "alt": "",
   "tags": [
    "Custom Sign"
   ],
   "about": "A custom sign made, fabricated and shipped by Signage.inc.",
   "hl": [
    "Customer service",
    "Matched expectations"
   ],
   "g": "other",
   "b": "other",
   "rel": [
    "pGJRyXZ5y",
    "-nRyWiPI3",
    "4NXsaFGgW"
   ]
  },
  {
   "id": "ar-KktCkD",
   "title": "Crystal S.’s Custom Sign",
   "business": "",
   "industry": "",
   "name": "Crystal S.",
   "date": "Jul 2026",
   "stars": 5,
   "text": "We just received it",
   "label": "Custom Sign",
   "type_id": null,
   "img": "",
   "w": 0,
   "h": 0,
   "alt": "",
   "tags": [
    "Custom Sign"
   ],
   "about": "A custom sign made, fabricated and shipped by Signage.inc.",
   "hl": [],
   "g": "other",
   "b": "other",
   "rel": [
    "-nRyWiPI3",
    "4NXsaFGgW",
    "LH-KsoMMh"
   ]
  },
  {
   "id": "ufxZn0G6FZ",
   "title": "Joe F.’s Custom Sign",
   "business": "",
   "industry": "",
   "name": "Joe F.",
   "date": "Feb 2026",
   "stars": 4,
   "text": "Nice",
   "label": "Custom Sign",
   "type_id": null,
   "img": "",
   "w": 0,
   "h": 0,
   "alt": "",
   "tags": [
    "Custom Sign"
   ],
   "about": "A custom sign made, fabricated and shipped by Signage.inc.",
   "hl": [],
   "g": "other",
   "b": "other",
   "rel": [
    "4NXsaFGgW",
    "LH-KsoMMh",
    "pGJRyXZ5y"
   ]
  },
  {
   "id": "6avRNcOeg",
   "title": "Lori C.’s Custom Sign",
   "business": "",
   "industry": "",
   "name": "Lori C.",
   "date": "Feb 2026",
   "stars": 3,
   "text": "There is only one color and it matches nothing in my office. When I asked why or for a remote no one ever got back to me. - This was a good experience up until this point. Now I am not very happy with my purchase.",
   "label": "Custom Sign",
   "type_id": null,
   "img": "",
   "w": 0,
   "h": 0,
   "alt": "",
   "tags": [
    "Custom Sign"
   ],
   "about": "A custom sign made, fabricated and shipped by Signage.inc.",
   "hl": [
    "Quality & finish"
   ],
   "g": "other",
   "b": "other",
   "rel": [
    "LH-KsoMMh",
    "pGJRyXZ5y",
    "-nRyWiPI3"
   ]
  },
  {
   "id": "c-UPFtGaT",
   "title": "Jerich O.’s Custom Sign",
   "business": "",
   "industry": "",
   "name": "Jerich O.",
   "date": "Feb 2026",
   "stars": 5,
   "text": "Great product delivered really fast and on time.. I will definitely use them again as well as recommend them for your next project.",
   "label": "Custom Sign",
   "type_id": null,
   "img": "",
   "w": 0,
   "h": 0,
   "alt": "",
   "tags": [
    "Custom Sign"
   ],
   "about": "A custom sign made, fabricated and shipped by Signage.inc.",
   "hl": [
    "Delivery",
    "Would order again",
    "Would recommend"
   ],
   "g": "other",
   "b": "other",
   "rel": [
    "pGJRyXZ5y",
    "-nRyWiPI3",
    "4NXsaFGgW"
   ]
  },
  {
   "id": "srrW0Ajhr",
   "title": "Kevin K.’s Custom Sign",
   "business": "",
   "industry": "",
   "name": "Kevin K.",
   "date": "Dec 2025",
   "stars": 5,
   "text": "Exactly as ordered, very happy with the sign!",
   "label": "Custom Sign",
   "type_id": null,
   "img": "",
   "w": 0,
   "h": 0,
   "alt": "",
   "tags": [
    "Custom Sign"
   ],
   "about": "A custom sign made, fabricated and shipped by Signage.inc.",
   "hl": [
    "Matched expectations"
   ],
   "g": "other",
   "b": "other",
   "rel": [
    "-nRyWiPI3",
    "4NXsaFGgW",
    "LH-KsoMMh"
   ]
  },
  {
   "id": "u_6WI2MH8",
   "title": "Brook F.’s Custom Sign",
   "business": "",
   "industry": "",
   "name": "Brook F.",
   "date": "Nov 2025",
   "stars": 5,
   "text": "From start to finish, the process was professional and easy. Communication was prompt and responsive and clear. I am very happy with the signs. They are just what we wanted.",
   "label": "Custom Sign",
   "type_id": null,
   "img": "",
   "w": 0,
   "h": 0,
   "alt": "",
   "tags": [
    "Custom Sign"
   ],
   "about": "A custom sign made, fabricated and shipped by Signage.inc.",
   "hl": [
    "Quality & finish",
    "Customer service"
   ],
   "g": "other",
   "b": "other",
   "rel": [
    "4NXsaFGgW",
    "LH-KsoMMh",
    "pGJRyXZ5y"
   ]
  },
  {
   "id": "tu2jnViws",
   "title": "Scott B.’s Custom Sign",
   "business": "",
   "industry": "",
   "name": "Scott B.",
   "date": "Oct 2025",
   "stars": 5,
   "text": "Great quality for the price.",
   "label": "Custom Sign",
   "type_id": null,
   "img": "",
   "w": 0,
   "h": 0,
   "alt": "",
   "tags": [
    "Custom Sign"
   ],
   "about": "A custom sign made, fabricated and shipped by Signage.inc.",
   "hl": [
    "Quality & finish",
    "Value"
   ],
   "g": "other",
   "b": "other",
   "rel": [
    "LH-KsoMMh",
    "pGJRyXZ5y",
    "-nRyWiPI3"
   ]
  },
  {
   "id": "cdVxMvw2n",
   "title": "Marcia A.’s Custom Sign",
   "business": "",
   "industry": "",
   "name": "Marcia A.",
   "date": "Oct 2025",
   "stars": 2,
   "text": "",
   "label": "Custom Sign",
   "type_id": null,
   "img": "",
   "w": 0,
   "h": 0,
   "alt": "",
   "tags": [
    "Custom Sign"
   ],
   "about": "A custom sign made, fabricated and shipped by Signage.inc.",
   "hl": [],
   "g": "other",
   "b": "other",
   "rel": [
    "pGJRyXZ5y",
    "-nRyWiPI3",
    "4NXsaFGgW"
   ]
  },
  {
   "id": "bf1zgSAb1",
   "title": "Jennifer M.’s Custom Sign",
   "business": "",
   "industry": "",
   "name": "Jennifer M.",
   "date": "Oct 2025",
   "stars": 5,
   "text": "SO SO happy with my sign!! It’s beautiful! We don’t have it hanging up yet! But we’re very excited! The bottom right dash is a little wiggly ☹️ is there an easy way for me to tighten that up?? Such a beautiful sign! Mahalo! Jennifer Martin 808.281.4292",
   "label": "Custom Sign",
   "type_id": null,
   "img": "",
   "w": 0,
   "h": 0,
   "alt": "",
   "tags": [
    "Custom Sign"
   ],
   "about": "A custom sign made, fabricated and shipped by Signage.inc.",
   "hl": [],
   "g": "other",
   "b": "other",
   "rel": [
    "-nRyWiPI3",
    "4NXsaFGgW",
    "LH-KsoMMh"
   ]
  }
 ],
 "typeFilters": [
  {
   "id": "all",
   "label": "All types",
   "n": 115
  },
  {
   "id": "3d-metal-backlit-letters",
   "label": "3D Metal Backlit Letters",
   "n": 36
  },
  {
   "id": "3d-acrylic-non-lit-letters",
   "label": "3D Acrylic Non-Lit Letters",
   "n": 15
  },
  {
   "id": "3d-non-lit-letters-on-backboard",
   "label": "3D Non-Lit Letters on Backboard",
   "n": 11
  },
  {
   "id": "2d-metal-letters",
   "label": "2D Metal Letters",
   "n": 10
  },
  {
   "id": "projecting-sign",
   "label": "Projecting Sign",
   "n": 9
  },
  {
   "id": "3d-acrylic-front-lit-letters",
   "label": "3D Acrylic Front Lit Letters",
   "n": 5
  },
  {
   "id": "raceway-mounted-letters",
   "label": "Raceway-Mounted Letters",
   "n": 5
  },
  {
   "id": "3d-metal-non-lit-letters",
   "label": "3D Metal Non-Lit Letters",
   "n": 5
  },
  {
   "id": "light-box-sign",
   "label": "Light Box Sign",
   "n": 4
  },
  {
   "id": "other",
   "label": "Other signs",
   "n": 15
  }
 ],
 "bizFilters": [
  {
   "id": "all",
   "label": "All work",
   "n": 115
  },
  {
   "id": "beauty",
   "label": "Beauty & Salons",
   "n": 26
  },
  {
   "id": "health",
   "label": "Health & Wellness",
   "n": 6
  },
  {
   "id": "food",
   "label": "Food & Drink",
   "n": 6
  },
  {
   "id": "pro",
   "label": "Professional & Public",
   "n": 6
  },
  {
   "id": "pets",
   "label": "Pets, Fitness & Auto",
   "n": 5
  },
  {
   "id": "other",
   "label": "Other Businesses",
   "n": 66
  }
 ],
 "stats": {
  "reviews": 115,
  "five": 104,
  "photos": 88
 },
 "featured": {
  "all": [
   "kWdZ7Pe0XM",
   "3cleXOnqho",
   "r6AIJ2ZjP2",
   "7HlLePBkRH",
   "OBLhjKMhuU",
   "v62DiEsFda",
   "oP5SMxDyz8",
   "UCPhdPHu-3",
   "xOVOppon6n",
   "kVjEqjKk1F",
   "6mE6NIV03",
   "dnPI_nmAsP"
  ],
  "cats": {
   "storefronts": [
    "kWdZ7Pe0XM",
    "3cleXOnqho",
    "r6AIJ2ZjP2",
    "7HlLePBkRH",
    "OBLhjKMhuU",
    "v62DiEsFda",
    "oP5SMxDyz8",
    "UCPhdPHu-3",
    "xOVOppon6n",
    "kVjEqjKk1F",
    "6mE6NIV03",
    "dnPI_nmAsP"
   ],
   "indoor": [
    "kWdZ7Pe0XM",
    "3cleXOnqho",
    "r6AIJ2ZjP2",
    "7HlLePBkRH",
    "OBLhjKMhuU",
    "v62DiEsFda",
    "oP5SMxDyz8",
    "UCPhdPHu-3",
    "xOVOppon6n",
    "kVjEqjKk1F",
    "6mE6NIV03",
    "dnPI_nmAsP"
   ],
   "outdoor": [
    "kWdZ7Pe0XM",
    "3cleXOnqho",
    "r6AIJ2ZjP2",
    "7HlLePBkRH",
    "OBLhjKMhuU",
    "v62DiEsFda",
    "oP5SMxDyz8",
    "UCPhdPHu-3",
    "xOVOppon6n",
    "kVjEqjKk1F",
    "6mE6NIV03",
    "dnPI_nmAsP"
   ],
   "restaurants": [
    "dnPI_nmAsP",
    "CKQ0OnLGuQ",
    "A0HNd4ni2Y",
    "NM7cWKLrNw",
    "yM7iwtYt_KM",
    "JYeZ8z3RFL",
    "WBniW_7kXq",
    "wI7PnRISP5",
    "kWdZ7Pe0XM",
    "3cleXOnqho",
    "r6AIJ2ZjP2",
    "7HlLePBkRH"
   ],
   "metal-backlit": [
    "kWdZ7Pe0XM",
    "3cleXOnqho",
    "r6AIJ2ZjP2",
    "7HlLePBkRH",
    "OBLhjKMhuU",
    "v62DiEsFda",
    "oP5SMxDyz8",
    "xOVOppon6n",
    "UCPhdPHu-3",
    "kVjEqjKk1F",
    "6mE6NIV03",
    "dnPI_nmAsP"
   ],
   "face-lit": [
    "kWdZ7Pe0XM",
    "3cleXOnqho",
    "r6AIJ2ZjP2",
    "7HlLePBkRH",
    "OBLhjKMhuU",
    "v62DiEsFda",
    "oP5SMxDyz8",
    "UCPhdPHu-3",
    "xOVOppon6n",
    "kVjEqjKk1F",
    "6mE6NIV03",
    "dnPI_nmAsP"
   ],
   "lightbox": [
    "CKQ0OnLGuQ",
    "JYeZ8z3RFL",
    "Q7n3zgXKIw",
    "Tp_ZfJa6yA",
    "AZmm7zcQ2",
    "iwpuf9DArY",
    "1jaEgEoS2k",
    "kWdZ7Pe0XM",
    "3cleXOnqho",
    "r6AIJ2ZjP2",
    "7HlLePBkRH",
    "OBLhjKMhuU"
   ],
   "channel-letters": [
    "kWdZ7Pe0XM",
    "3cleXOnqho",
    "r6AIJ2ZjP2",
    "7HlLePBkRH",
    "OBLhjKMhuU",
    "v62DiEsFda",
    "oP5SMxDyz8",
    "UCPhdPHu-3",
    "xOVOppon6n",
    "kVjEqjKk1F",
    "6mE6NIV03",
    "dnPI_nmAsP"
   ]
  }
 },
 "source": {
  "name": "Loox",
  "site": "https://loox.io",
  "url": "https://loox.io/widget/1B-FUy5fym/reviews"
 }
};
